import { defineComponent as y, openBlock as o, createBlock as I, resolveDynamicComponent as D, normalizeClass as p, withCtx as E, createElementBlock as s, renderSlot as S, createCommentVNode as f, createElementVNode as l, createVNode as V, unref as C, ref as N, toDisplayString as c, withModifiers as z, computed as w, onMounted as W, onBeforeUnmount as q, normalizeStyle as U, createTextVNode as F, watch as x, withKeys as Q, withDirectives as H, createSlots as ee, vModelText as X, mergeProps as ge, nextTick as P, reactive as K, Fragment as re, renderList as de, onUnmounted as ye } from "vue";
const ve = {
  key: 0,
  class: "bitTabIconLeft"
}, be = { class: "bitTabText" }, $e = {
  key: 1,
  class: "bitTabIconRight"
}, te = /* @__PURE__ */ y({
  __name: "tabButton",
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    isFluidWidth: {
      type: Boolean,
      default: !1
    },
    isFitWidth: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: null
    },
    tag: {
      type: String,
      default: "button"
    },
    color: {
      type: String,
      default: "gray"
    },
    size: {
      type: String,
      default: "md"
    },
    isWithExternalIcon: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, a) => (o(), I(D(e.tag), {
      class: p(["bitTab", [
        `bitTabSize-${e.size}`,
        `bitTabColor-${e.color}`,
        {
          active: e.active,
          bitTabFullWidth: e.isFluidWidth,
          bitTabFitWidth: e.isFitWidth,
          bitTabDisabled: e.disabled,
          bitTabSquare: e.variant === "square",
          bitTabSquareSmall: e.variant === "square-sm",
          bitTabFilter: e.variant === "filter",
          withExternalIcon: e.isWithExternalIcon
        }
      ]])
    }, {
      default: E(() => [
        t.$slots.appendIcon ? (o(), s("span", ve, [
          S(t.$slots, "appendIcon")
        ])) : f("", !0),
        l("span", be, [
          S(t.$slots, "default")
        ]),
        t.$slots.prependIcon ? (o(), s("span", $e, [
          S(t.$slots, "prependIcon")
        ])) : f("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Be = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, Se = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M10.734 18.266A1.037 1.037 0 1 1 9.266 16.8l4.8-4.8-4.8-4.798-.07-.08a1.038 1.038 0 0 1 1.459-1.459l.079.071 5.533 5.533a1.037 1.037 0 0 1 0 1.467z"
}, null, -1), Ie = [
  Se
];
function Ce(e, t) {
  return o(), s("svg", Be, [...Ie]);
}
const Y = { render: Ce }, Te = /* @__PURE__ */ y({
  __name: "expandButton",
  props: {
    isExpanded: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, a) => (o(), I(te, {
      class: p(["bitNavExpandButton", { bitNavExpandButtonExpanded: e.isExpanded }]),
      variant: "square"
    }, {
      default: E(() => [
        V(C(Y), { class: "bitNavExpandButtonIcon" })
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), we = { class: "bitAccordionItemSummaryTitle" }, ke = { class: "bitAccordionItemContent" }, Mi = /* @__PURE__ */ y({
  __name: "accordionItem",
  props: {
    title: {
      type: String,
      required: !0
    },
    variant: {
      type: String,
      default: null
    }
  },
  setup(e) {
    const t = N(!1), a = () => {
      t.value = !t.value;
    };
    return (i, n) => (o(), s("details", {
      class: p(["bitAccordionItem", e.variant])
    }, [
      l("summary", {
        class: "bitAccordionItemSummary",
        onClick: a
      }, [
        l("h4", we, c(e.title), 1),
        V(Te, {
          class: "bitAccordionItemButton",
          "is-expanded": t.value
        }, null, 8, ["is-expanded"])
      ]),
      l("div", ke, [
        S(i.$slots, "default")
      ])
    ], 2));
  }
}), Me = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, Le = /* @__PURE__ */ l("path", {
  fill: "#A2A8C3",
  d: "M6.343 6.343a1 1 0 0 1 1.414 0L12 10.586l4.243-4.243a1 1 0 1 1 1.414 1.414L13.414 12l4.243 4.243a1 1 0 1 1-1.414 1.414L12 13.414l-4.243 4.243a1 1 0 0 1-1.414-1.414L10.586 12 6.343 7.757a1 1 0 0 1 0-1.414"
}, null, -1), Ae = [
  Le
];
function Ve(e, t) {
  return o(), s("svg", Me, [...Ae]);
}
const Ee = { render: Ve }, Ne = /* @__PURE__ */ y({
  __name: "closeButton",
  props: {
    variant: {
      type: String,
      default: "close"
    }
  },
  setup(e) {
    return (t, a) => (o(), s("button", {
      class: p(["bitCloseButton", `bitCloseButton-${e.variant}`])
    }, [
      V(C(Ee))
    ], 2));
  }
}), _e = { class: "bitBottomSheetHeader" }, Li = /* @__PURE__ */ y({
  __name: "bottomSheetHeader",
  props: {
    title: {
      type: String,
      required: !0
    }
  },
  emits: ["close"],
  setup(e) {
    return (t, a) => (o(), s("div", _e, [
      l("p", null, c(e.title), 1),
      V(Ne, {
        class: "bitDropdownContentModalCloseIcon",
        onClick: a[0] || (a[0] = z((i) => t.$emit("close"), ["prevent"]))
      })
    ]));
  }
}), xe = ["type", "gtmid"], De = ["gtmid"], We = ["gtmid"], Re = ["gtmid"], Fe = {
  key: 2,
  class: "buttonLoadingicon"
}, oe = /* @__PURE__ */ y({
  __name: "button",
  props: {
    type: { default: "primary" },
    variant: { default: null },
    isFluidWidth: { type: Boolean },
    isFitWidth: { type: Boolean },
    disabled: { type: Boolean },
    widthSize: { default: "max" },
    maxWidthSize: { default: null },
    heightSize: { default: "md" },
    loading: { type: Boolean },
    typeButton: { default: "button" },
    mobileOnly: { type: Boolean },
    noMargin: { type: Boolean },
    gtmid: { default: null },
    isSpecialButton: { type: Boolean }
  },
  setup(e) {
    const t = e, a = w(() => [
      {
        fluidWidth: t.isFluidWidth,
        fitWidth: t.isFitWidth,
        disabled: t.disabled,
        loading: t.loading,
        mobileOnly: t.mobileOnly,
        noMargin: t.noMargin,
        specialButton: t.isSpecialButton
      },
      t.type,
      t.maxWidthSize ? "maxWidth" + t.maxWidthSize : "",
      "height" + t.heightSize,
      t.variant
    ]);
    return (i, n) => (o(), s("button", {
      type: i.typeButton,
      class: p(["button", a.value]),
      gtmid: i.gtmid
    }, [
      i.$slots.appendIcon ? (o(), s("span", {
        key: 0,
        class: "buttonIconLeft",
        gtmid: i.gtmid
      }, [
        S(i.$slots, "appendIcon")
      ], 8, De)) : f("", !0),
      l("span", {
        class: "buttonTextInside",
        gtmid: i.gtmid
      }, [
        S(i.$slots, "default")
      ], 8, We),
      i.$slots.prependIcon ? (o(), s("span", {
        key: 1,
        class: "buttonIconRight",
        gtmid: i.gtmid
      }, [
        S(i.$slots, "prependIcon")
      ], 8, Re)) : f("", !0),
      i.loading ? (o(), s("span", Fe)) : f("", !0)
    ], 10, xe));
  }
}), Ai = /* @__PURE__ */ y({
  __name: "controlButton",
  props: {
    tooltipPosition: { default: "left" },
    tooltipText: {},
    isActive: { type: Boolean }
  },
  setup(e) {
    return (t, a) => (o(), s("button", {
      class: p(["bitControlButton", { activeControlButton: t.isActive }])
    }, [
      S(t.$slots, "default"),
      l("span", {
        class: p(["controlButtonTooltip", t.tooltipPosition])
      }, c(t.tooltipText), 3)
    ], 2));
  }
}), Pe = {
  key: 0,
  class: "bitLinkButtonIconLeft"
}, Oe = { class: "bitLinkButtonTextInside" }, He = {
  key: 1,
  class: "bitLinkButtonIconRight"
}, Vi = /* @__PURE__ */ y({
  __name: "linkButton",
  props: {
    disabled: { type: Boolean },
    tag: { default: "button" }
  },
  setup(e) {
    return (t, a) => (o(), I(D(t.tag), {
      class: p(["bitLinkButton", { bitLinkButtonDisabled: t.disabled }])
    }, {
      default: E(() => [
        t.$slots.appendIcon ? (o(), s("span", Pe, [
          S(t.$slots, "appendIcon")
        ])) : f("", !0),
        l("span", Oe, [
          S(t.$slots, "default")
        ]),
        t.$slots.prependIcon ? (o(), s("span", He, [
          S(t.$slots, "prependIcon")
        ])) : f("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), ze = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}, qe = /* @__PURE__ */ l("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ l("path", {
    fill: "#fff",
    "fill-rule": "evenodd",
    d: "M16 0a16 16 0 1 0 16 16A16.02 16.02 0 0 0 16 0m0 29.333A13.334 13.334 0 1 1 29.333 16 13.347 13.347 0 0 1 16 29.333m0-16h-1.333a1.333 1.333 0 1 0 0 2.667H16v8a1.333 1.333 0 0 0 2.667 0v-8A2.667 2.667 0 0 0 16 13.333m2-4.666a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
    "clip-rule": "evenodd"
  })
], -1), Ue = /* @__PURE__ */ l("defs", null, [
  /* @__PURE__ */ l("clipPath", { id: "a" }, [
    /* @__PURE__ */ l("path", {
      fill: "#fff",
      d: "M0 0h32v32H0z"
    })
  ])
], -1), Ge = [
  qe,
  Ue
];
function Ke(e, t) {
  return o(), s("svg", ze, [...Ge]);
}
const je = { render: Ke }, Ei = /* @__PURE__ */ y({
  __name: "overlayButton",
  props: {
    position: { default: "bottom-right" },
    minWidthToChangePosition: { default: null }
  },
  setup(e) {
    const t = e, a = N(t.position), i = () => {
      window.innerWidth < t.minWidthToChangePosition ? a.value = t.position === "bottom-right" ? "top-left" : "bottom-right" : a.value = t.position;
    };
    return W(() => {
      t.minWidthToChangePosition && window && (i(), window.addEventListener("resize", i));
    }), q(() => {
      window.removeEventListener("resize", i);
    }), (n, d) => (o(), s("button", {
      class: p(["bitOverlayButton", a.value])
    }, [
      V(C(je))
    ], 2));
  }
}), Ye = { class: "offerBlock" }, Je = /* @__PURE__ */ l("div", { class: "offerRadio" }, [
  /* @__PURE__ */ l("div", { class: "offerRadioInner" }, [
    /* @__PURE__ */ l("div", { class: "offerRadioDot" })
  ])
], -1), Ze = { class: "offerRadioLogo" }, Qe = ["src"], Xe = {
  key: 1,
  class: "offerRadioLogoName"
}, et = { class: "offerBtcAmount" }, tt = {
  key: 0,
  class: "offerLabel"
}, Ni = /* @__PURE__ */ y({
  __name: "buyCryptoOffer",
  props: {
    imageUrl: {
      type: String,
      required: !1,
      default: ""
    },
    active: {
      type: Boolean,
      default: !1
    },
    offerLabel: {
      type: String,
      required: !1,
      default: ""
    },
    offerAmount: {
      type: [String, Number],
      required: !1,
      default: ""
    },
    offerCurrency: {
      type: String,
      required: !1,
      default: ""
    },
    methodName: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    return (t, a) => (o(), s("div", {
      class: p(["offer", [{ selected: e.active }]])
    }, [
      l("div", Ye, [
        Je,
        l("div", Ze, [
          e.imageUrl ? (o(), s("img", {
            key: 0,
            src: e.imageUrl,
            alt: "paymentLogo"
          }, null, 8, Qe)) : f("", !0),
          e.methodName ? (o(), s("span", Xe, c(e.methodName), 1)) : f("", !0)
        ])
      ]),
      l("div", et, c(e.offerAmount) + " " + c(e.offerCurrency), 1),
      e.offerLabel ? (o(), s("div", tt, c(e.offerLabel), 1)) : f("", !0)
    ], 2));
  }
}), at = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [i, n] of t)
    a[i] = n;
  return a;
}, nt = {}, ot = { class: "bitTooltipText" };
function it(e, t) {
  return o(), s("span", ot, [
    S(e.$slots, "default")
  ]);
}
const st = /* @__PURE__ */ at(nt, [["render", it]]), lt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, rt = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16m-.7 6a1 1 0 0 0 0 2v4a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1zm.7-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
}, null, -1), dt = [
  rt
];
function ut(e, t) {
  return o(), s("svg", lt, [...dt]);
}
const ct = { render: ut }, ae = /* @__PURE__ */ y({
  __name: "tooltip",
  props: {
    tooltipText: {
      type: String,
      default: ""
    },
    tooltipPosition: {
      type: String,
      default: "top-right"
    },
    iconSize: {
      type: Number,
      default: null
    },
    tag: {
      type: String,
      default: "span"
    },
    tooltipWidth: {
      type: String,
      default: null
    },
    tooltipOffset: {
      type: String,
      default: "5px"
    },
    variant: {
      type: String,
      default: null
    },
    isShowOnHover: {
      type: Boolean,
      default: !1
    },
    isTooltipAnchor: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = N(!1), a = N(), i = () => {
      clearTimeout(a.value), t.value ? t.value = !1 : (t.value = !0, a.value = setTimeout(() => {
        t.value = !1;
      }, 3e3));
    };
    return (n, d) => (o(), I(D(e.tag), {
      class: p(["bitTooltip", [{ bitTooltipHover: e.isShowOnHover, bitTooltipAnchor: e.isTooltipAnchor }, e.variant]])
    }, {
      default: E(() => [
        l("span", {
          class: p(["bitTooltipTrigger", e.iconSize ? `bitTooltipIconSize${e.iconSize}` : ""]),
          onClick: i
        }, [
          n.$slots.tooltipTrigger ? S(n.$slots, "tooltipTrigger", { key: 1 }) : (o(), I(C(ct), { key: 0 }))
        ], 2),
        t.value || e.isShowOnHover ? (o(), I(st, {
          key: 0,
          class: p(["bitTooltipTextTooltip", e.tooltipPosition]),
          style: U({
            "--tooltip-width": e.tooltipWidth,
            "--tooltip-offset": e.tooltipOffset
          })
        }, {
          default: E(() => [
            F(c(e.tooltipText), 1)
          ]),
          _: 1
        }, 8, ["style", "class"])) : f("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), mt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, ht = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M17.25 9A2.753 2.753 0 0 1 20 11.75v5.5A2.753 2.753 0 0 1 17.25 20h-5.5A2.753 2.753 0 0 1 9 17.25V16h3.251A3.753 3.753 0 0 0 16 12.251V9zm-5-5A2.753 2.753 0 0 1 15 6.749v5.501c0 .73-.291 1.428-.807 1.943l-.2.183c-.42.344-.932.556-1.472.61L12.25 15h-5.5A2.753 2.753 0 0 1 4 12.25v-5.5A2.753 2.753 0 0 1 6.75 4z"
}, null, -1), pt = [
  ht
];
function ft(e, t) {
  return o(), s("svg", mt, [...pt]);
}
const ue = { render: ft }, gt = { class: "buyCryptoTransactionItem buyCryptoTransactionItemData" }, yt = { class: "buyCryptoTransactionItem buyCryptoTransactionItemStatus" }, vt = { class: "buyCryptoTransactionItem buyCryptoTransactionItemAmount" }, bt = {
  key: 0,
  class: "buyCryptoTransactionContainer"
}, $t = { class: "buyCryptoTransactionList" }, Bt = { class: "buyCryptoTransactionItem buyCryptoTransactionItemName" }, St = { class: "buyCryptoTransactionItem" }, It = { class: "buyCryptoTransactionItemAddress" }, Ct = { class: "buyCryptoTransactionList buyCryptoTransactionListMobile" }, Tt = { class: "buyCryptoTransactionItem buyCryptoTransactionItemName" }, wt = { class: "buyCryptoTransactionItem" }, kt = { class: "buyCryptoTransactionItem buyCryptoTransactionItemName" }, Mt = { class: "buyCryptoTransactionItemMobile" }, Lt = { class: "buyCryptoTransactionItemName" }, At = { class: "buyCryptoTransactionItemInside" }, Vt = { class: "buyCryptoTransactionItem buyCryptoTransactionItemDetails" }, Et = { class: "buyCryptoTransactionItemMobile" }, Nt = { class: "buyCryptoTransactionItemName" }, _t = { class: "buyCryptoTransactionItemInside" }, _i = /* @__PURE__ */ y({
  __name: "buyCryptoTransactions",
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    date: {
      type: String,
      default: ""
    },
    time: {
      type: String,
      default: ""
    },
    amount: {
      type: String,
      default: ""
    },
    currency: {
      type: String,
      default: ""
    },
    nameTransactionId: {
      type: String,
      default: ""
    },
    iDTransaction: {
      type: String,
      default: ""
    },
    paymentName: {
      type: String,
      default: ""
    },
    paymentNameCard: {
      type: String,
      default: ""
    },
    paymentDetailsAmountName: {
      type: String,
      default: ""
    },
    paymentDetailsAmount: {
      type: String,
      default: ""
    },
    paymentDetailsAmountNameTo: {
      type: String,
      default: ""
    },
    paymentDetailsAmountTo: {
      type: String,
      default: ""
    },
    currencyFrom: {
      type: String,
      default: ""
    },
    successCopiedText: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, a = N(!1), i = async () => {
      try {
        await navigator.clipboard.writeText(t.iDTransaction);
      } catch (n) {
        console.error(n);
      }
    };
    return (n, d) => (o(), s("div", {
      class: p(["buyCryptoTransaction", [{ selected: e.active }]])
    }, [
      l("div", {
        class: "buyCryptoTransactionWrapper",
        onClick: d[0] || (d[0] = (u) => a.value = !a.value)
      }, [
        l("div", gt, c(e.date) + " " + c(e.time), 1),
        l("div", yt, [
          S(n.$slots, "default")
        ]),
        l("div", vt, c(e.amount) + " " + c(e.currency), 1),
        V(C(Y), {
          class: p(["buyCryptoTransactionArrow", [{ rotateActive: a.value }]])
        }, null, 8, ["class"])
      ]),
      a.value ? (o(), s("div", bt, [
        l("div", $t, [
          l("div", Bt, c(e.nameTransactionId), 1),
          l("div", St, [
            l("div", It, c(e.iDTransaction), 1),
            V(ae, {
              "tooltip-text": e.successCopiedText,
              "tooltip-width": "auto",
              "icon-size": 18
            }, {
              tooltipTrigger: E(() => [
                V(C(ue), {
                  class: "buyCryptoTransactionCopyIcon",
                  onClick: i
                })
              ]),
              _: 1
            }, 8, ["tooltip-text"])
          ])
        ]),
        l("div", Ct, [
          l("div", Tt, c(e.paymentName), 1),
          l("div", wt, c(e.paymentNameCard), 1)
        ]),
        l("div", kt, [
          l("div", Mt, [
            l("span", Lt, c(e.paymentDetailsAmountName), 1),
            l("span", At, c(e.paymentDetailsAmount) + " " + c(e.currencyFrom), 1)
          ])
        ]),
        l("div", Vt, [
          l("div", Et, [
            l("span", Nt, c(e.paymentDetailsAmountNameTo), 1),
            l("span", _t, c(e.paymentDetailsAmountTo) + " " + c(e.currency), 1)
          ])
        ])
      ])) : f("", !0)
    ], 2));
  }
}), xi = /* @__PURE__ */ y({
  __name: "cardLabel",
  props: {
    colorTheme: {
      type: String,
      default: "blue"
    },
    customColor: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, a) => (o(), s("span", {
      class: p(["bitCardLabel", e.customColor ? "" : e.colorTheme]),
      style: U({ "--custom-color": e.customColor })
    }, [
      S(t.$slots, "default")
    ], 6));
  }
}), xt = { class: "cashbackCard" }, Dt = { class: "cashbackCardTitle" }, Wt = { class: "cashbackCardList" }, Rt = { class: "cashbackCardItem" }, Ft = { class: "cashbackCardItem cashbackCardItemRight" }, Pt = { class: "cashbackCardItem" }, Ot = { class: "cashbackCardItem cashbackCardItemRight" }, Ht = { class: "cashbackCardItem" }, zt = { class: "cashbackCardItem cashbackCardItemRight" }, Di = /* @__PURE__ */ y({
  __name: "cashbackCard",
  props: {
    titleNumber: {
      type: String,
      default: ""
    },
    textMinDeposit: {
      type: String,
      default: ""
    },
    numberMinDeposit: {
      type: String,
      default: ""
    },
    textMinLoss: {
      type: String,
      default: ""
    },
    numberMinLoss: {
      type: String,
      default: ""
    },
    wager: {
      type: String,
      default: ""
    },
    numberWager: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, a) => (o(), s("div", xt, [
      l("div", Dt, c(e.titleNumber), 1),
      l("ul", Wt, [
        l("li", Rt, c(e.textMinDeposit), 1),
        l("li", Ft, c(e.numberMinDeposit), 1),
        l("li", Pt, c(e.textMinLoss), 1),
        l("li", Ot, c(e.numberMinLoss), 1),
        l("li", Ht, c(e.wager), 1),
        l("li", zt, c(e.numberWager), 1)
      ])
    ]));
  }
}), qt = ["src"], Ut = {
  key: 0,
  class: "bitCollectionCardTitle"
}, Gt = {
  key: 1,
  class: "bitCollectionCardTitle"
}, Wi = /* @__PURE__ */ y({
  __name: "collectionCard",
  props: {
    imageUrl: {
      type: String,
      required: !0
    },
    bgHexColorStart: {
      type: String,
      default: void 0
    },
    bgHexColorEnd: {
      type: String,
      default: void 0
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["cardClick"],
  setup(e) {
    return (t, a) => (o(), s("div", {
      class: p(["bitCollectionCard", { bitCollectionCardCustomBg: e.bgHexColorStart && e.bgHexColorEnd }]),
      style: U({
        "--card-gradient-start": `#${e.bgHexColorStart}`,
        "--card-gradient-end": `#${e.bgHexColorEnd}`
      }),
      onClick: a[0] || (a[0] = z((i) => t.$emit("cardClick"), ["prevent"]))
    }, [
      l("img", {
        class: "bitCollectionCardImage",
        src: e.imageUrl,
        alt: "selectorsSearchResultsItem"
      }, null, 8, qt),
      t.$slots["custom-title"] ? (o(), s("p", Ut, [
        S(t.$slots, "custom-title")
      ])) : (o(), s("p", Gt, c(e.title), 1))
    ], 6));
  }
}), Kt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, jt = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M12 4a8 8 0 1 1 0 16 8.01 8.01 0 0 1-8-8 8 8 0 0 1 8-8m0 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1"
}, null, -1), Yt = [
  jt
];
function Jt(e, t) {
  return o(), s("svg", Kt, [...Yt]);
}
const j = { render: Jt }, Zt = { class: "bitInputCheckboxLabel" }, Qt = ["checked", "value", "readonly", "indeterminate", "gtmid"], Xt = /* @__PURE__ */ l("span", { class: "bitInputCheckboxChecked" }, null, -1), ea = {
  key: 0,
  class: "bitInputCheckboxIcon"
}, ta = {
  key: 1,
  class: "bitInputCheckboxName"
}, aa = {
  key: 2,
  class: "bitInputCheckboxName"
}, na = {
  key: 0,
  class: /* @__PURE__ */ p(["bitCheckboxErrorText"])
}, Ri = /* @__PURE__ */ y({
  __name: "checkbox",
  props: {
    modelValue: { type: [Boolean, Array] },
    value: { default: null },
    labelText: { default: "" },
    gtmid: {},
    isError: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    indeterminate: { type: Boolean },
    fieldToCompareValue: {},
    errorMessage: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = e, i = t, n = (u) => {
      const m = u.target.checked;
      if (Array.isArray(a.modelValue)) {
        let h = [...a.modelValue];
        m ? h.push(a.value || "") : h = a.fieldToCompareValue ? h.filter(
          (v) => v[a.fieldToCompareValue] !== a.value[a.fieldToCompareValue]
        ) : h.filter((v) => v !== a.value), i("update:modelValue", h);
      } else
        i("update:modelValue", m);
    }, d = w(() => Array.isArray(a.modelValue) ? a.fieldToCompareValue ? a.modelValue.some(
      (u) => u[a.fieldToCompareValue] === a.value[a.fieldToCompareValue]
    ) : a.modelValue.includes(a.value) : a.modelValue);
    return x(
      () => a.fieldToCompareValue,
      (u) => {
        Array.isArray(a.modelValue) && typeof a.value == "string" && u && console.error(
          "Checkbox error: Пропс fieldToCompareValue нужен только если modelValue массив объектов"
        );
      },
      { immediate: !0 }
    ), (u, m) => (o(), s("div", {
      class: p(["bitInputCheckbox", {
        bitInputCheckboxError: u.isError,
        bitInputCheckboxDisabled: u.disabled,
        bitInputCheckboxReadonly: u.readonly,
        bitInputCheckboxIndeterminate: u.indeterminate
      }])
    }, [
      l("label", Zt, [
        l("input", {
          type: "checkbox",
          checked: d.value,
          value: u.value,
          readonly: u.readonly,
          indeterminate: u.indeterminate,
          class: p(["bitInputCheckboxInput", { active: u.indeterminate }]),
          gtmid: u.gtmid,
          onChange: n
        }, null, 42, Qt),
        Xt,
        u.$slots.prependInputIcon ? (o(), s("span", ea, [
          S(u.$slots, "prependInputIcon")
        ])) : f("", !0),
        u.labelText.length >= 1 ? (o(), s("span", ta, c(u.labelText), 1)) : u.$slots.label ? (o(), s("span", aa, [
          S(u.$slots, "label")
        ])) : f("", !0)
      ]),
      u.isError && u.errorMessage ? (o(), s("div", na, [
        V(C(j), { class: "bitCheckboxErrorIcon" }),
        l("p", null, c(u.errorMessage), 1)
      ])) : f("", !0)
    ], 2));
  }
}), oa = { class: "bitRadioButtonLabel" }, ia = ["value", "checked", "name", "gtmid", "disabled"], sa = /* @__PURE__ */ l("span", { class: "bitRadioButtonCheck" }, null, -1), la = { class: "bitRadioButtonLabelIcon" }, ie = /* @__PURE__ */ y({
  __name: "radioButton",
  props: {
    modelValue: { default: "" },
    formFieldName: {},
    variant: { default: null },
    label: { default: "" },
    disabled: { type: Boolean },
    isError: { type: Boolean },
    radioValue: {},
    gtmid: { default: null }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = t, i = (n) => {
      const d = n.target;
      a("update:modelValue", d.value);
    };
    return (n, d) => (o(), s("div", {
      class: p(["bitRadioButton", [
        n.variant,
        {
          bitRadioButtonDisabled: n.disabled,
          bitRadioButtonError: n.isError,
          bitRadioButtonChecked: n.modelValue === n.radioValue
        }
      ]])
    }, [
      l("label", oa, [
        l("input", {
          type: "radio",
          value: n.radioValue,
          checked: n.modelValue === n.radioValue,
          name: n.formFieldName,
          gtmid: n.gtmid,
          class: "bitRadioButtonInput",
          disabled: n.disabled,
          onChange: i
        }, null, 40, ia),
        sa,
        F(" " + c(n.label) + " ", 1),
        l("span", la, [
          S(n.$slots, "prependIcon")
        ])
      ])
    ], 2));
  }
}), ra = { class: "bitSwitchLabel" }, da = ["disabled", "checked"], ua = /* @__PURE__ */ l("span", { class: "bitSwitchSwitch" }, null, -1), Fi = /* @__PURE__ */ y({
  __name: "switch",
  props: {
    modelValue: { type: Boolean },
    labelRight: { default: "" },
    labelLeft: { default: "" },
    disabled: { type: Boolean },
    minimal: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = t, i = (n) => {
      const d = n.target;
      a("update:modelValue", d.checked);
    };
    return (n, d) => (o(), s("div", {
      class: p(["bitSwitch", {
        bitSwitchDisabled: n.disabled,
        bitSwitchChecked: n.modelValue,
        bitSwitchMinimal: n.minimal
      }])
    }, [
      n.labelLeft ? (o(), s("span", {
        key: 0,
        class: p(["bitSwitchTitle", { bitSwitchTitleActive: !n.modelValue }]),
        onClick: d[0] || (d[0] = (u) => n.$emit("update:modelValue", !1))
      }, c(n.labelLeft), 3)) : f("", !0),
      l("label", ra, [
        l("input", {
          type: "checkbox",
          class: "bitSwitchInput",
          disabled: n.disabled,
          checked: n.modelValue,
          onChange: i
        }, null, 40, da),
        ua
      ]),
      n.labelRight ? (o(), s("span", {
        key: 1,
        class: p(["bitSwitchTitle", { bitSwitchTitleActive: n.modelValue }]),
        onClick: d[1] || (d[1] = (u) => n.$emit("update:modelValue", !0))
      }, c(n.labelRight), 3)) : f("", !0)
    ], 2));
  }
}), ca = ["gtm-id"], ma = ["src", "gtmid"], ha = ["gtmid"], Pi = /* @__PURE__ */ y({
  __name: "collectionFilterItem",
  props: {
    imageUrl: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    gtmId: {
      type: String,
      default: ""
    },
    isActive: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["cardClick"],
  setup(e) {
    return (t, a) => (o(), s("div", {
      "gtm-id": e.gtmId,
      class: p(["bitCollectionFilterItem", { bitCollectionFilterItemActive: e.isActive }]),
      onClick: a[0] || (a[0] = z((i) => t.$emit("cardClick"), ["prevent"]))
    }, [
      l("img", {
        src: e.imageUrl,
        alt: "selectorsSearchResultsCollectionItem",
        gtmid: e.gtmId
      }, null, 8, ma),
      l("p", { gtmid: e.gtmId }, c(e.title), 9, ha)
    ], 10, ca));
  }
}), pa = ["gtmid"], fa = ["src", "alt", "gtmid"], Oi = /* @__PURE__ */ y({
  __name: "providerFilterItem",
  props: {
    imageUrl: {
      type: String,
      required: !0
    },
    imageAlt: {
      type: String,
      default: ""
    },
    gtmId: {
      type: String,
      default: ""
    },
    isActive: {
      type: Boolean,
      default: !1
    },
    isDisabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["cardClick"],
  setup(e) {
    return (t, a) => (o(), s("div", {
      gtmid: e.gtmId,
      class: p([
        "bitProviderFilterItem",
        { bitProviderFilterItemActive: e.isActive },
        { bitProviderFilterItemDisabled: e.isDisabled }
      ]),
      onClick: a[0] || (a[0] = z((i) => t.$emit("cardClick"), ["prevent"]))
    }, [
      l("img", {
        src: e.imageUrl,
        alt: e.imageAlt,
        gtmid: e.gtmId
      }, null, 8, fa)
    ], 10, pa));
  }
}), ga = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, ya = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M15.65 5A4.25 4.25 0 0 0 12 7.19 4.25 4.25 0 0 0 8.35 5a4.513 4.513 0 0 0-4.314 4.679c0 3.017 3.177 6.313 5.84 8.547a3.3 3.3 0 0 0 4.248 0c2.663-2.234 5.84-5.53 5.84-8.547A4.513 4.513 0 0 0 15.65 5"
}, null, -1), va = [
  ya
];
function ba(e, t) {
  return o(), s("svg", ga, [...va]);
}
const $a = { render: ba }, Ba = ["data-is-favourite"], Hi = /* @__PURE__ */ y({
  __name: "favoriteIconButton",
  props: {
    isFavourite: {
      type: Boolean,
      default: !1
    },
    isDisabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, a) => (o(), s("button", {
      class: p(["bitFavoriteIconButton", { bitFavoriteIconButtonDisabled: e.isDisabled }]),
      "data-is-favourite": e.isFavourite
    }, [
      V(C($a))
    ], 10, Ba));
  }
}), Sa = ["data-color"], zi = /* @__PURE__ */ y({
  __name: "thumbLabel",
  props: {
    label: {
      type: Object,
      required: !0
    },
    variant: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, a) => (o(), s("p", {
      "data-color": e.label.color,
      style: U({
        "--card-custom-color": e.label.customColor ? `#${e.label.customColor}` : null
      }),
      class: p([
        "bitThumbLabel",
        e.variant ? `bitThumbLabel-${e.variant}` : "",
        { bitThumbLabelWithGradient: e.label.customColor }
      ])
    }, c(e.label.title), 15, Sa));
  }
}), Ia = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, Ca = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M12 3a6 6 0 0 1 1 11.915v2.08h1.995l.103.005a1 1 0 0 1 0 1.99l-.103.005H13V20l-.005.102a1 1 0 0 1-1.99 0L11 20v-1.005H8.995a1 1 0 0 1 0-2H11v-2.08A6 6 0 0 1 12 3m0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
}, null, -1), Ta = [
  Ca
];
function wa(e, t) {
  return o(), s("svg", Ia, [...Ta]);
}
const ka = { render: wa }, Ma = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, La = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M18.838 4a1 1 0 0 1 .995.898l.005.102v4.243l-.005.102a1 1 0 0 1-1.989 0l-.006-.102v-1.83l-2.95 2.95a6 6 0 1 1-9.13-.766 6 6 0 0 1 7.717-.649L16.425 6h-1.829a1 1 0 1 1 0-2zm-6.01 7.01a4 4 0 1 0-5.657 5.658 4 4 0 0 0 5.657-5.657"
}, null, -1), Aa = [
  La
];
function Va(e, t) {
  return o(), s("svg", Ma, [...Aa]);
}
const Ea = { render: Va }, Na = { class: "bitGenderSelection" }, _a = {
  key: 0,
  class: "bitGenderSelectionErrorMessage"
}, qi = /* @__PURE__ */ y({
  __name: "genderSelection",
  props: {
    modelValue: {},
    isError: { type: Boolean },
    isDisabled: { type: Boolean },
    maleTitle: {},
    femaleTitle: {},
    errorMessage: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e) {
    return (t, a) => (o(), s("div", Na, [
      V(ie, {
        "model-value": t.modelValue,
        "radio-value": "m",
        variant: "group",
        label: t.maleTitle,
        gtmid: "SignUp_TypeSex",
        "form-field-name": "checkboxGender",
        "is-error": t.isError,
        disabled: t.isDisabled,
        "onUpdate:modelValue": a[0] || (a[0] = (i) => t.$emit("update:modelValue", i))
      }, {
        prependIcon: E(() => [
          V(C(Ea))
        ]),
        _: 1
      }, 8, ["model-value", "label", "is-error", "disabled"]),
      V(ie, {
        "model-value": t.modelValue,
        "radio-value": "f",
        variant: "group",
        label: t.femaleTitle,
        gtmid: "SignUp_TypeSex",
        "form-field-name": "checkboxGender",
        "is-error": t.isError,
        disabled: t.isDisabled,
        "onUpdate:modelValue": a[1] || (a[1] = (i) => t.$emit("update:modelValue", i))
      }, {
        prependIcon: E(() => [
          V(C(ka))
        ]),
        _: 1
      }, 8, ["model-value", "label", "is-error", "disabled"]),
      t.isError && t.errorMessage ? (o(), s("p", _a, c(t.errorMessage), 1)) : f("", !0)
    ]));
  }
}), G = {
  modelValue: {
    type: [String, Number],
    default: () => ""
  },
  placeholder: {
    type: String,
    default: ""
  },
  formFieldName: {
    type: String,
    default: null
  },
  isError: {
    type: Boolean,
    default: !1
  },
  errorMessage: {
    type: String,
    default: ""
  },
  isValid: {
    type: Boolean,
    default: !1
  },
  isWarning: {
    type: Boolean,
    default: !1
  },
  warningMessage: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: !1
  },
  locked: {
    type: Boolean,
    default: !1
  },
  inputClass: {
    type: String,
    default: ""
  },
  maxlength: {
    type: Number,
    default: null
  },
  focusTrigger: {
    type: Boolean,
    default: !1
  },
  isNoMargin: {
    type: Boolean,
    default: !1
  },
  textLabel: {
    type: String,
    default: ""
  },
  defaultValue: {
    type: String,
    default: ""
  },
  focusWithoutScrolling: {
    type: Boolean,
    default: !1
  },
  gtmid: {
    type: String,
    default: null
  }
}, xa = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, Da = /* @__PURE__ */ l("path", {
  fill: "#05c756",
  d: "M17.445 6.36a2 2 0 0 1 2.829 0l.136.152a2 2 0 0 1-.136 2.676l-8.575 8.574-.152.137a2 2 0 0 1-2.524 0l-.153-.137-5.359-5.36a2 2 0 0 1-.137-2.675l.137-.153a2 2 0 0 1 2.83 0l3.943 3.946z"
}, null, -1), Wa = [
  Da
];
function Ra(e, t) {
  return o(), s("svg", xa, [...Wa]);
}
const ne = { render: Ra }, Fa = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, Pa = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M12 3a5 5 0 0 1 5 5v1a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-5a3 3 0 0 1 3-3V8a5 5 0 0 1 5-5m0 10a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m0-8a3 3 0 0 0-3 3v1h6V8a3 3 0 0 0-3-3"
}, null, -1), Oa = [
  Pa
];
function Ha(e, t) {
  return o(), s("svg", Fa, [...Oa]);
}
const ce = { render: Ha }, za = {
  key: 0,
  class: "bitInputLabel"
}, qa = {
  key: 0,
  class: "bitInputPrependIcon"
}, Ua = ["id", "value", "type", "inputmode", "step", "name", "placeholder", "maxlength", "disabled", "gtmid"], Ga = ["id", "value", "type", "name", "placeholder", "maxlength", "disabled", "gtmid"], Ka = {
  key: 3,
  class: "bitInputRightIcon"
}, ja = {
  key: 3,
  class: "bitInputAppendIcon"
}, Ya = {
  key: 1,
  class: "bitInputMessages"
}, Ja = ["innerHTML"], Za = {
  key: 1,
  class: "bitInputErrorText"
}, Qa = {
  key: 2,
  class: "bitInputWarningText"
}, Xa = { key: 3 }, J = /* @__PURE__ */ y({
  __name: "input",
  props: {
    ...G,
    type: {
      type: String,
      default: "text"
    },
    inputMode: {
      type: String,
      default: null
    },
    isWithAppendMainIcon: {
      type: Boolean,
      default: !1
    },
    inputWrapperClass: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: "default"
    }
  },
  emits: ["update:modelValue", "update:modelValueDecimalWithDot", "keyup", "keyup-enter", "click", "change", "keypress"],
  setup(e, { emit: t }) {
    const a = e, i = t, n = N(null);
    x(
      () => a.focusTrigger,
      () => {
        var r;
        return (r = n.value) == null ? void 0 : r.focus();
      }
    );
    const d = (r) => {
      const M = r.target;
      let L = M.value.replace(/[\u0400-\u04FF]/g, "");
      if (a.type === "decimal-number") {
        L = L.replace(/[^0-9.,]/g, "");
        const O = L.search(/[.,]/);
        O !== -1 && (L = L.slice(0, O + 1) + L.slice(O + 1).replace(/[.,]/g, "")), /^0\d/.test(L) && (L = L.replace(/^0+/, "") || "0"), L = L.replace(",", "."), M.value = L, i("update:modelValue", L);
      } else
        i("update:modelValue", L);
    }, u = (r) => {
      const M = r.target;
      i("change", M.value);
    }, m = (r) => {
      const M = r.target;
      i("keyup", M.value);
    }, h = (r) => {
      const M = r.target;
      i("keyup-enter", M.value);
    }, v = (r) => {
      i("click", r);
    }, B = (r) => {
      const M = String.fromCharCode(r.which || r.keyCode);
      /[\u0400-\u04FF]/.test(M) ? r.preventDefault() : i("keypress", r);
    }, b = (r) => {
      var L;
      const M = (L = r.clipboardData) == null ? void 0 : L.getData("text");
      M && /[\u0400-\u04FF]/.test(M) && r.preventDefault();
    }, g = w(() => !a.locked && !a.disabled), A = () => {
      var r;
      (r = n.value) == null || r.blur();
    }, k = w(() => a.errorMessage.replace(/\[([^[]+)\]\(([^(]+)\)/gm, (...r) => `<a href="${r[2]}">${r[1]}</a>`)), _ = w(() => /\[([^[]+)\]\(([^(]+)\)/gm.test(a.errorMessage)), T = () => {
      window.addEventListener("touchmove", A, { once: !0 });
    }, $ = () => {
      window.removeEventListener("touchmove", A);
    };
    return W(() => {
      var r;
      if (a.defaultValue) {
        i("update:modelValue", a.defaultValue);
        return;
      }
      a.focusTrigger && ((r = n.value) == null || r.focus({ preventScroll: a.focusWithoutScrolling }));
    }), q(() => window.removeEventListener("touchmove", A)), (r, M) => (o(), s("div", {
      class: p(["bitInput", [
        {
          bitInputNoMargin: r.isNoMargin,
          bitInputTextarea: e.variant === "textarea",
          bitInputError: r.isError && g.value,
          bitInputSuccess: r.isValid && g.value,
          bitInputWarning: r.isWarning && g.value,
          bitInputDisabled: r.locked || r.disabled,
          bitInputWithMessage: (r.errorMessage || r.warningMessage || r.$slots.inputMessage) && g.value
        }
      ]])
    }, [
      r.textLabel ? (o(), s("label", za, c(r.textLabel), 1)) : f("", !0),
      l("div", {
        class: p(["bitInputWrapper", e.inputWrapperClass])
      }, [
        r.$slots.prependInputIcon ? (o(), s("span", qa, [
          S(r.$slots, "prependInputIcon")
        ])) : f("", !0),
        e.variant !== "textarea" ? (o(), s("input", {
          key: 1,
          id: r.formFieldName || void 0,
          ref_key: "inputRef",
          ref: n,
          value: r.modelValue,
          type: e.type === "decimal-number" ? "text" : e.type,
          inputmode: e.inputMode,
          step: e.type === "decimal-number" ? "0.01" : void 0,
          name: r.formFieldName || void 0,
          class: p(r.inputClass),
          placeholder: r.placeholder || void 0,
          maxlength: r.maxlength,
          disabled: r.disabled || r.locked,
          tabindex: "0",
          gtmid: r.gtmid,
          onInput: d,
          onChange: u,
          onKeyup: [
            Q(h, ["enter"]),
            m
          ],
          onClick: v,
          onKeypress: B,
          onFocus: T,
          onBlur: $,
          onPaste: b
        }, null, 42, Ua)) : (o(), s("textarea", {
          key: 2,
          id: r.formFieldName || void 0,
          ref_key: "inputRef",
          ref: n,
          value: r.modelValue,
          type: e.type,
          name: r.formFieldName || void 0,
          class: p(r.inputClass),
          placeholder: r.placeholder || void 0,
          maxlength: r.maxlength,
          disabled: r.disabled,
          tabindex: "0",
          gtmid: r.gtmid,
          onInput: d,
          onChange: u,
          onKeyup: [
            Q(h, ["enter"]),
            m
          ],
          onClick: v,
          onKeypress: B,
          onFocus: T,
          onBlur: $,
          onPaste: b
        }, null, 42, Ga)),
        r.locked || r.isError && g.value && !e.isWithAppendMainIcon || r.isValid && g.value && !e.isWithAppendMainIcon || r.$slots.appendInputIcon && !r.isError || e.isWithAppendMainIcon ? (o(), s("div", Ka, [
          r.locked ? (o(), I(C(ce), {
            key: 0,
            class: "bitInputIcon"
          })) : f("", !0),
          r.isError && g.value && !e.isWithAppendMainIcon ? (o(), I(C(j), {
            key: 1,
            class: "bitInputIcon"
          })) : f("", !0),
          r.isValid && g.value && !e.isWithAppendMainIcon ? (o(), I(C(ne), {
            key: 2,
            class: "bitInputIcon"
          })) : f("", !0),
          r.$slots.appendInputIcon && !r.isError || e.isWithAppendMainIcon ? (o(), s("span", ja, [
            S(r.$slots, "appendInputIcon")
          ])) : f("", !0)
        ])) : f("", !0)
      ], 2),
      (r.errorMessage || r.warningMessage || r.$slots.inputMessage) && g.value ? (o(), s("div", Ya, [
        _.value ? (o(), s("span", {
          key: 0,
          class: "bitInputErrorText",
          innerHTML: k.value
        }, null, 8, Ja)) : r.isError ? (o(), s("span", Za, c(r.errorMessage), 1)) : r.isWarning ? (o(), s("span", Qa, [
          V(C(j), { class: "bitInputIcon" }),
          F(" " + c(r.warningMessage), 1)
        ])) : r.$slots.inputMessage ? (o(), s("span", Xa, [
          S(r.$slots, "inputMessage")
        ])) : f("", !0)
      ])) : f("", !0)
    ], 2));
  }
}), Ui = /* @__PURE__ */ y({
  __name: "cardDateInput",
  props: {
    ...G,
    modelValue: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "keyup"],
  setup(e, { emit: t }) {
    const a = e, i = t, n = (m) => {
      m.length === 2 && a.modelValue.length === 1 && (m = `${m}/`), m.length === 2 && a.modelValue.length === 3 && (m = `${m[0]}`), i("update:modelValue", m);
    }, d = (m) => {
      /[0-9]/g.test(m.key) || m.preventDefault();
    }, u = (m) => {
      i("keyup", m);
    };
    return (m, h) => (o(), I(J, {
      "input-class": m.inputClass,
      "model-value": e.modelValue,
      placeholder: m.placeholder,
      maxlength: 5,
      "is-full-width": !0,
      "is-no-margin": m.isNoMargin,
      "is-input-full-width": !0,
      "focus-trigger": m.focusTrigger,
      "is-valid": m.isValid,
      "is-error": m.isError,
      "error-message": m.errorMessage,
      type: "tel",
      "form-field-name": "credit-card-date",
      "onUpdate:modelValue": n,
      onKeypress: d,
      onKeyupEnter: u
    }, null, 8, ["input-class", "model-value", "placeholder", "is-no-margin", "focus-trigger", "is-valid", "is-error", "error-message"]));
  }
}), me = (e) => {
  e.nodeName.toLowerCase() !== "input" && (e = e.querySelector("input"));
  const t = (n) => n.replace(/\D/g, "").slice(0, 16).replace(/(\d{4})(?=\d)/g, "$1 ").trim(), a = () => {
    const n = e.value, d = e.selectionStart, u = e.selectionStart !== e.selectionEnd, m = t(n);
    if (e.value = m, !u && n !== m) {
      const h = m.length - n.length;
      e.setSelectionRange(d + h, d + h);
    }
  }, i = (n) => {
    e.value.replace(/\D/g, "").length >= 16 && !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(n.key) && n.preventDefault();
  };
  e.addEventListener("input", a), e.addEventListener("paste", () => setTimeout(a, 0)), e.addEventListener("keyup", a), e.addEventListener("keydown", i);
}, Gi = /* @__PURE__ */ y({
  __name: "cardNumberInput",
  props: G,
  emits: ["update:modelValue", "keyup"],
  setup(e, { emit: t }) {
    const a = me, i = t, n = (u) => {
      i("update:modelValue", u);
    }, d = (u) => {
      i("keyup", u);
    };
    return (u, m) => H((o(), I(J, {
      "model-value": u.modelValue,
      placeholder: u.placeholder,
      "is-valid": u.isValid,
      "is-error": u.isError,
      "error-message": u.errorMessage,
      "focus-trigger": u.focusTrigger,
      "focus-without-scrolling": u.focusWithoutScrolling,
      type: "tel",
      "form-field-name": "credit-card-number",
      "onUpdate:modelValue": n,
      onKeyupEnter: d
    }, null, 8, ["model-value", "placeholder", "is-valid", "is-error", "error-message", "focus-trigger", "focus-without-scrolling"])), [
      [C(a)]
    ]);
  }
}), Ki = /* @__PURE__ */ y({
  __name: "cvvInput",
  props: {
    ...G,
    cvvTextTooltip: {
      type: String,
      default: ""
    },
    tooltipWidth: {
      type: String,
      default: null
    }
  },
  emits: ["update:modelValue", "click", "keyup"],
  setup(e, { emit: t }) {
    const a = me, i = t, n = (m) => {
      i("update:modelValue", m);
    }, d = (m) => {
      i("click", m);
    }, u = (m) => {
      i("keyup", m);
    };
    return (m, h) => H((o(), I(J, {
      class: "bitCvvInput",
      "model-value": m.modelValue,
      placeholder: m.placeholder,
      maxlength: 4,
      "is-no-margin": m.isNoMargin,
      "focus-trigger": m.focusTrigger,
      "is-valid": m.isValid,
      "is-error": m.isError,
      "error-message": m.errorMessage,
      type: "password",
      "input-mode": "numeric",
      "form-field-name": "cvv",
      "onUpdate:modelValue": n,
      onClick: d,
      onKeyupEnter: u
    }, ee({ _: 2 }, [
      !m.isError && !m.isValid ? {
        name: "appendInputIcon",
        fn: E(() => [
          V(ae, {
            "tooltip-text": e.cvvTextTooltip,
            "tooltip-width": e.tooltipWidth,
            onClick: h[0] || (h[0] = z(() => {
            }, ["stop"]))
          }, null, 8, ["tooltip-text", "tooltip-width"])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["model-value", "placeholder", "is-no-margin", "focus-trigger", "is-valid", "is-error", "error-message"])), [
      [C(a), void 0, "restrictNumeric"]
    ]);
  }
}), en = {
  key: 0,
  class: "bitInputBonusCodeTitle"
}, tn = { class: "bitInputBonusCodeWrapper" }, an = ["readonly", "placeholder"], nn = {
  key: 2,
  class: "bitInputBonusCodeRightSide"
}, on = { class: "bitInputBonusCodeWithApplyIcons" }, sn = { class: "bitInputBonusCodeWithApplyButtons" }, ln = {
  key: 3,
  class: "bitInputBonusCodeRightSide"
}, rn = {
  key: 1,
  class: "bitInputBonusCodeErrorMessage"
}, ji = /* @__PURE__ */ y({
  __name: "inputBonusCode",
  props: {
    variant: {
      type: String,
      default: "copy"
    },
    applyButtonText: {
      type: String,
      default: ""
    },
    removeButtonText: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    applyButtonType: {
      type: String,
      default: "primary"
    },
    valueBonusCode: {
      type: String,
      default: ""
    },
    isError: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    isNoBonusCode: {
      type: Boolean,
      default: !1
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    successCopiedText: {
      type: String,
      default: ""
    },
    titleBonus: {
      type: String,
      default: ""
    }
  },
  emits: ["apply", "remove", "changed"],
  setup(e, { emit: t }) {
    const a = e, i = t, n = N(!1), d = N(!1), u = N(), m = N(!1), h = N(""), v = () => {
      i("apply", h.value);
    }, B = async () => {
      try {
        clearTimeout(u.value), await navigator.clipboard.writeText(a.valueBonusCode), n.value = !0, m.value = !0, a.variant !== "with-apply" && (d.value = !0);
      } catch (g) {
        console.error(g);
      }
      i("apply", h.value);
    }, b = () => {
      n.value = !1, m.value = !1, d.value = !1, h.value = "", i("remove");
    };
    return x(
      () => a.valueBonusCode,
      () => {
        h.value = a.valueBonusCode, a.variant !== "copy-textarea" && !a.isError && (n.value = !!a.valueBonusCode);
      },
      { immediate: !0 }
    ), (g, A) => (o(), s("div", {
      class: p(["bitInputBonusCode", {
        bitInputBonusCodeReadonly: m.value || e.valueBonusCode.length > 0 && !e.isError,
        bitInputBonusCodeError: e.isError,
        bitInputBonusCodeLoading: e.isLoading,
        bitInputBonusCodeWithApply: e.variant === "with-apply",
        bitInputBonusCodeCopy: e.variant !== "with-apply"
      }])
    }, [
      e.titleBonus ? (o(), s("p", en, c(e.titleBonus), 1)) : f("", !0),
      l("div", tn, [
        H(l("textarea", {
          "onUpdate:modelValue": A[0] || (A[0] = (k) => h.value = k),
          class: "bitInputBonusCodeHiddenTextarea",
          name: "areaCopy"
        }, null, 512), [
          [X, h.value]
        ]),
        e.variant !== "copy-textarea" && !e.isNoBonusCode ? H((o(), s("input", {
          key: 0,
          "onUpdate:modelValue": A[1] || (A[1] = (k) => h.value = k),
          type: "text",
          class: p({
            bitInputBonusCodeLong: e.valueBonusCode.length > 30,
            bitInputBonusCodeLong100: e.valueBonusCode.length > 99
          }),
          name: "bonuscode",
          maxlength: "100",
          readonly: m.value || e.valueBonusCode.length > 0 && !e.isError,
          placeholder: e.placeholder,
          onInput: A[2] || (A[2] = (k) => g.$emit("changed", h.value))
        }, null, 42, an)), [
          [X, h.value]
        ]) : (o(), s("div", {
          key: 1,
          name: "areaCopy",
          class: p(["bitInputBonusCodeTextAreaCopy", { bitInputBonusCodeTextAreaNoCode: e.isNoBonusCode }])
        }, c(h.value), 3)),
        e.variant === "with-apply" ? (o(), s("div", nn, [
          l("div", on, [
            n.value && !e.isError ? (o(), I(C(ne), {
              key: 0,
              onClick: B
            })) : f("", !0),
            e.isError ? (o(), I(C(j), { key: 1 })) : f("", !0)
          ]),
          l("div", sn, [
            !n.value || e.isError ? (o(), I(oe, {
              key: 0,
              variant: "input",
              type: e.applyButtonType,
              disabled: !h.value.length || e.isLoading,
              loading: e.isLoading,
              onClick: v
            }, {
              default: E(() => [
                F(c(e.applyButtonText), 1)
              ]),
              _: 1
            }, 8, ["type", "disabled", "loading"])) : (o(), I(oe, {
              key: 1,
              type: "secondary",
              loading: e.isLoading,
              disabled: e.isLoading,
              variant: "input",
              onClick: b
            }, {
              default: E(() => [
                F(c(e.removeButtonText), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          ])
        ])) : e.isNoBonusCode ? f("", !0) : (o(), s("div", ln, [
          V(ae, {
            "tooltip-text": e.successCopiedText,
            "tooltip-width": "auto",
            "icon-size": 24
          }, {
            tooltipTrigger: E(() => [
              V(C(ue), {
                class: "bitInputBonusCodeCopyIcon",
                onClick: B
              })
            ]),
            _: 1
          }, 8, ["tooltip-text"])
        ]))
      ]),
      e.isError ? (o(), s("span", rn, c(e.errorMessage), 1)) : f("", !0)
    ], 2));
  }
}), dn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, un = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M18.436 4.293a1 1 0 0 1 1.414 1.414l-1.84 1.84-2.216 2.215V9.76l-1.074 1.074v.001L5.707 19.85l-.075.07a1.001 1.001 0 0 1-1.408-1.408l.069-.076 1.857-1.859a11.3 11.3 0 0 1-2.6-2.78 3.21 3.21 0 0 1 0-3.59C4.713 8.447 7.358 5.5 12 5.5c1.675 0 3.09.385 4.269.958zm1.029 4.626c.403.457.73.9.985 1.286.733 1.1.733 2.49 0 3.591-1.163 1.757-3.808 4.705-8.45 4.705-.688 0-1.33-.068-1.933-.184l2.149-2.149c2.383-.107 4.28-1.93 4.282-4.167l-.005-.11zM12 7.827c-2.484 0-4.498 1.87-4.498 4.174 0 .895.305 1.723.821 2.403l1.055-1.055A2.6 2.6 0 0 1 9.002 12c0-1.536 1.342-2.782 2.998-2.782.447 0 .87.094 1.252.257l1.057-1.057A4.74 4.74 0 0 0 12 7.827"
}, null, -1), cn = [
  un
];
function mn(e, t) {
  return o(), s("svg", dn, [...cn]);
}
const hn = { render: mn }, pn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, fn = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M12 5.5c4.642 0 7.287 2.948 8.45 4.705.733 1.1.733 2.49 0 3.59-1.163 1.758-3.808 4.706-8.45 4.706s-7.287-2.948-8.45-4.705a3.21 3.21 0 0 1 0-3.59C4.713 8.447 7.358 5.5 12 5.5m0 2.327c-2.484 0-4.498 1.87-4.498 4.174S9.516 16.174 12 16.174c2.483-.002 4.495-1.87 4.498-4.173 0-2.305-2.014-4.174-4.498-4.174m0 1.392c1.656 0 2.999 1.245 2.999 2.782S13.656 14.783 12 14.783s-2.999-1.246-3-2.782 1.344-2.782 3-2.782"
}, null, -1), gn = [
  fn
];
function yn(e, t) {
  return o(), s("svg", pn, [...gn]);
}
const vn = { render: yn }, bn = { class: "bitPasswordInputMessage" }, Yi = /* @__PURE__ */ y({
  __name: "passwordInput",
  props: {
    ...G,
    isWithoutMessages: {
      type: Boolean,
      default: !1
    },
    msgPasswordStrong: {
      type: String,
      default: ""
    },
    msgPasswordMedium: {
      type: String,
      default: ""
    },
    msgPasswordWeak: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, a = N(!1), i = N(!1), n = w(() => a.value ? "text" : "password"), d = (B) => B ? /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{11,40}$/.test(B) ? "STRONG" : B.length > 9 ? "MEDIUM" : B.length > 7 ? "WEAK" : "" : "", u = w(() => d(String(t.modelValue))), m = w(() => {
      switch (u.value) {
        case "STRONG":
          return t.msgPasswordStrong;
        case "MEDIUM":
          return t.msgPasswordMedium;
        case "WEAK":
          return t.msgPasswordWeak;
        default:
          return "";
      }
    }), h = w(() => ({
      ...t,
      isWithoutMessages: null,
      msgPasswordStrong: null,
      msgPasswordMedium: null,
      msgPasswordWeak: null
    })), v = () => {
      a.value = !a.value, P(() => i.value = !i.value);
    };
    return (B, b) => (o(), I(J, ge({
      class: ["bitPasswordInput", e.isWithoutMessages ? "" : `bitPasswordInput-${u.value}`]
    }, { ...h.value }, {
      type: n.value,
      "is-with-append-main-icon": "",
      "input-wrapper-class": "bitPasswordInputWrapper",
      "onUpdate:modelValue": b[0] || (b[0] = (g) => B.$emit("update:modelValue", g))
    }), ee({
      appendInputIcon: E(() => [
        a.value ? (o(), I(C(hn), {
          key: 0,
          onClick: v
        })) : (o(), I(C(vn), {
          key: 1,
          onClick: v
        }))
      ]),
      _: 2
    }, [
      u.value && !e.isWithoutMessages ? {
        name: "inputMessage",
        fn: E(() => [
          l("span", bn, c(m.value), 1)
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class", "type"]));
  }
}), $n = { class: "bitRedirectMenuItemImg" }, Bn = { class: "bitRedirectMenuItemText" }, Ji = /* @__PURE__ */ y({
  __name: "redirectMenuItem",
  props: {
    tag: {
      type: String,
      default: "a"
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, a) => (o(), I(D(e.tag), { class: "bitRedirectMenuItem" }, {
      default: E(() => [
        l("span", $n, [
          S(t.$slots, "image")
        ]),
        l("span", Bn, c(e.title), 1)
      ]),
      _: 3
    }));
  }
}), se = (e, t, a, i = {}) => {
  const n = document.createElement("div");
  let d = null;
  const u = () => {
    d && clearTimeout(d);
    const h = e.getBoundingClientRect(), v = n.getBoundingClientRect();
    let B, b;
    B = h.left + h.width * 0.5, b = h.top + h.height / 2 - v.height / 2, n.style.transform = `translate(${B}px, ${b}px)`, n.style.opacity = "0", document.body.removeEventListener("mousewheel", u), setTimeout(() => {
      var g;
      (g = document.querySelector(".bitTooltipGlobal")) == null || g.remove();
    }, 120);
  }, m = () => {
    var k;
    n.className = "bitTooltipGlobal " + (((k = i.tooltipClasses) == null ? void 0 : k.join(" ")) || ""), n.innerText = t, document.body.appendChild(n);
    const h = e.getBoundingClientRect(), v = n.getBoundingClientRect();
    let B, b, g, A;
    B = h.left + h.width * 0.5, b = h.top + h.height / 2 - v.height / 2, n.style.transition = "none", n.style.transform = `translate(${B}px, ${b}px)`, setTimeout(() => {
      n.style.removeProperty("transition"), n.style.position = "fixed", n.style.top = "0", n.style.left = "0", n.style.opacity = "1", g = h.left + h.width + (i.offset || 0), A = h.top + h.height / 2 - v.height / 2, n.style.transform = `translate(${g}px, ${A}px)`, document.body.addEventListener("mousewheel", u, { passive: !0 });
    }, 50);
  };
  return i.forceCreate && m(), e.addEventListener("mouseenter", () => {
    window.matchMedia("(hover: hover) and (pointer: fine)").matches && window.innerWidth >= 1366 && (d = setTimeout(() => {
      m();
    }, 200));
  }), e.addEventListener("mouseleave", u), n;
}, Sn = {
  key: 0,
  class: "bitTrailMenuItemContent"
}, Zi = /* @__PURE__ */ y({
  __name: "trailMenuItem",
  props: {
    isWithTooltip: {
      type: Boolean,
      default: !1
    },
    isDisabledMargin: {
      type: Boolean,
      default: !1
    },
    isWithoutText: {
      type: Boolean,
      default: !1
    },
    isActive: {
      type: Boolean,
      default: !1
    },
    tooltipText: {
      type: String,
      default: ""
    },
    tooltipOffset: {
      type: Number,
      default: 0
    },
    tooltipClass: {
      type: String,
      default: ""
    },
    tag: {
      type: String,
      default: "a"
    }
  },
  setup(e) {
    const t = e, a = N(null), i = N(null);
    return x(
      () => t.isWithTooltip,
      (n) => {
        i.value ? n ? i.value.style.removeProperty("visibility") : i.value.style.visibility = "hidden" : !i.value && n && (i.value = se(a.value, t.tooltipText, "right", {
          tooltipClasses: ["bitTrailMenuItemTooltip", t.tooltipClass],
          offset: 12 + t.tooltipOffset
        }));
      }
    ), W(() => {
      a.value && t.isWithTooltip && (i.value = se(a.value, t.tooltipText, "right", {
        tooltipClasses: ["bitTrailMenuItemTooltip", t.tooltipClass],
        offset: 12 + t.tooltipOffset
      }));
    }), (n, d) => (o(), I(D(e.tag), {
      ref_key: "itemRef",
      ref: a,
      class: p([
        "bitTrailMenuItem",
        {
          bitTrailMenuItemActive: e.isActive,
          bitTrailMenuItemWithTooltip: e.isWithTooltip || e.isWithoutText,
          bitTrailMenuItemWithoutSlot: !n.$slots.default
        }
      ])
    }, {
      default: E(() => [
        n.$slots.default ? (o(), s("span", Sn, [
          S(n.$slots, "default")
        ])) : f("", !0),
        !e.isWithoutText && !e.isWithTooltip ? (o(), s("p", {
          key: 1,
          class: p(["bitTrailMenuItemText", { bitTrailMenuItemNoMargin: e.isDisabledMargin }])
        }, c(e.tooltipText), 3)) : f("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), le = /* @__PURE__ */ y({
  __name: "arrowButton",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    direction: {
      type: String,
      default: "right"
    },
    size: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, a = w(() => t.size === "sm" ? "square-sm" : "square");
    return (i, n) => (o(), I(te, {
      class: p(["bitNavArrowButton", [`bitNavArrowButton-${e.direction}`]]),
      variant: a.value,
      disabled: e.disabled
    }, {
      default: E(() => [
        V(C(Y), { class: "bitNavArrowButtonIcon" })
      ]),
      _: 1
    }, 8, ["class", "variant", "disabled"]));
  }
}), Qi = /* @__PURE__ */ y({
  __name: "menuScrollable",
  props: {
    resizeTrigger: {
      type: [Array, Object],
      default: null
    },
    listMaxWidth: {
      type: String,
      default: "100%"
    },
    listClass: {
      type: String,
      default: ""
    },
    scrollTo: {
      type: Number,
      default: null
    },
    activeChildClass: {
      type: String,
      default: "active"
    },
    variant: {
      type: String,
      default: null
    },
    isWithNavOnMob: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = N(null), i = K({
      left: !1,
      right: !1
    });
    let n;
    const d = () => {
      var b, g, A, k, _;
      i.right = Math.ceil(((b = a.value) == null ? void 0 : b.scrollLeft) || 0) < (((g = a.value) == null ? void 0 : g.scrollWidth) || 0) - (((A = a.value) == null ? void 0 : A.clientWidth) || 0) && (((k = a.value) == null ? void 0 : k.scrollWidth) || 0) > (((_ = a.value) == null ? void 0 : _.clientWidth) || 0);
    }, u = () => {
      d(), B();
    }, m = () => {
      var b, g, A, k;
      i.left = !!((b = a.value) != null && b.scrollLeft), i.right = Math.ceil(((g = a.value) == null ? void 0 : g.scrollLeft) || 0) < (((A = a.value) == null ? void 0 : A.scrollWidth) || 0) - (((k = a.value) == null ? void 0 : k.clientWidth) || 0);
    }, h = () => {
      var b;
      (b = a.value) == null || b.scroll({ left: 0, behavior: "smooth" });
    }, v = () => {
      var b, g;
      (g = a.value) == null || g.scroll({
        left: (b = a.value) == null ? void 0 : b.scrollWidth,
        behavior: "smooth"
      });
    }, B = () => {
      var A;
      const b = a.value, g = (A = a.value) == null ? void 0 : A.querySelector(`.${t.activeChildClass}`);
      if (b && g) {
        const k = window.innerWidth < 768 && !t.isWithNavOnMob ? 32 : 72, _ = g.offsetLeft + g.offsetWidth + k, T = b.scrollLeft + b.offsetWidth;
        b.scrollLeft > g.offsetLeft ? b.scrollLeft = g.offsetLeft - k : T < _ && (b.scrollLeft += _ - T);
      }
    };
    return x(
      () => t.resizeTrigger,
      async () => {
        await P(), u();
      },
      { immediate: !0, deep: !0 }
    ), W(() => {
      window.addEventListener("resize", u), P(() => u()), a.value && (n = new MutationObserver(u), n.observe(a.value, {
        childList: !0,
        subtree: !0
      }), B());
    }), q(() => {
      window.removeEventListener("resize", u), n == null || n.disconnect();
    }), (b, g) => (o(), s("div", {
      class: p(["bitMenuScrollable", [
        {
          leftShadow: i.left,
          rightShadow: i.right,
          bitMenuScrollableWithNavOnMob: e.isWithNavOnMob
        },
        e.variant
      ]]),
      style: U({ "--list-max-width": e.listMaxWidth })
    }, [
      V(le, {
        class: p(["bitMenuScrollableArrowButton bitMenuScrollableArrowButtonLeft", {
          bitMenuScrollableArrowButtonActive: i.left
        }]),
        size: "sm",
        onClick: h
      }, null, 8, ["class"]),
      V(le, {
        class: p(["bitMenuScrollableArrowButton bitMenuScrollableArrowButtonRight", {
          bitMenuScrollableArrowButtonActive: i.right
        }]),
        size: "sm",
        onClick: v
      }, null, 8, ["class"]),
      l("div", {
        ref_key: "menuListRef",
        ref: a,
        class: p(["bitMenuScrollableList", e.listClass]),
        onScroll: m,
        onVnodeUpdated: d
      }, [
        S(b.$slots, "default")
      ], 34)
    ], 6));
  }
}), Xi = /* @__PURE__ */ y({
  __name: "headerNavButton",
  props: {
    active: {
      type: Boolean,
      default: () => !1
    }
  },
  setup(e) {
    return (t, a) => (o(), s("div", {
      class: p(["bitHeaderNavButton", { bitHeaderNavButtonActive: e.active }])
    }, [
      S(t.$slots, "default")
    ], 2));
  }
}), In = { class: "bitNavBarAdditionalButton" }, Cn = { class: "bitNavBarAdditionalButtonIcon" }, Tn = { class: "bitNavBarAdditionalButtonTitle" }, es = /* @__PURE__ */ y({
  __name: "navBarAdditionalButton",
  props: {
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, a) => (o(), s("button", In, [
      l("span", Cn, [
        S(t.$slots, "icon")
      ]),
      l("span", Tn, c(e.title), 1)
    ]));
  }
}), wn = { class: "bitNavBarRegularButtonIcon" }, ts = /* @__PURE__ */ y({
  __name: "navBarRegularButton",
  props: {
    title: {
      type: String,
      required: !0
    },
    isActive: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, a) => (o(), s("button", {
      class: p(["bitNavBarRegularButton", { bitNavBarRegularButtonActive: e.isActive }])
    }, [
      l("span", wn, [
        S(t.$slots, "icon")
      ]),
      l("span", null, c(e.title), 1)
    ], 2));
  }
}), kn = ["gtmid"], Mn = {
  key: 0,
  class: "bitPaymentMethodCardBonusLabel"
}, Ln = ["data-method-logo-id", "gtmid"], An = ["src", "gtmid"], Vn = ["src", "gtmid"], En = ["gtmid"], Nn = ["gtmid"], as = /* @__PURE__ */ y({
  __name: "paymentMethodCard",
  props: {
    method: {
      type: Object,
      required: !0
    },
    minText: {
      type: String,
      required: !0
    },
    paymentBonusLabelTitle: {
      type: String,
      default: null
    },
    isActive: {
      type: Boolean,
      default: !1
    },
    textRecomended: {
      type: String,
      required: !0
    }
  },
  emits: ["methodMounted", "methodClick"],
  setup(e, { emit: t }) {
    const a = e, i = t;
    return W(() => {
      P(() => {
        i("methodMounted", a.isActive);
      });
    }), (n, d) => {
      var u;
      return o(), s("div", {
        class: p(["bitPaymentMethodCard", { bitPaymentMethodCardActive: e.isActive }]),
        gtmid: "payment_methods_" + e.method.methodLogoId,
        onClick: d[0] || (d[0] = (m) => n.$emit("methodClick"))
      }, [
        e.paymentBonusLabelTitle ? (o(), s("span", Mn, c(e.paymentBonusLabelTitle), 1)) : f("", !0),
        l("div", {
          class: "bitPaymentMethodCardBlockLogo",
          "data-method-logo-id": e.method.methodLogoId,
          gtmid: "payment_methods_" + e.method.methodLogoId
        }, [
          e.method.payment_provider_logo ? (o(), s("img", {
            key: 0,
            class: "bitPaymentMethodCardLogo",
            src: (u = e.method.payment_provider_logo) == null ? void 0 : u.url,
            gtmid: "payment_methods_" + e.method.methodLogoId,
            alt: "Payment method"
          }, null, 8, An)) : e.method.iconSrc ? (o(), s("img", {
            key: 1,
            class: "bitPaymentMethodCardLogo",
            src: e.method.iconSrc,
            gtmid: "payment_methods_" + e.method.methodLogoId,
            alt: "Payment method"
          }, null, 8, Vn)) : f("", !0)
        ], 8, Ln),
        l("span", {
          class: "bitPaymentMethodCardMethodMin",
          gtmid: "payment_methods_" + e.method.methodLogoId
        }, c(e.minText), 9, En),
        e.method.recomended && e.textRecomended ? (o(), s("span", {
          key: 1,
          class: "bitPaymentMethodCardRecomended",
          gtmid: "payment_methods_" + e.method.methodLogoId
        }, c(e.textRecomended), 9, Nn)) : f("", !0)
      ], 10, kn);
    };
  }
}), _n = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, xn = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M10 4a7 7 0 0 1 6.007 10.593l4.478 4.478a1 1 0 0 1-1.414 1.414l-4.334-4.334A7 7 0 1 1 10 4m2.825 4.173a1 1 0 0 0-1.414 0L9.993 9.59 8.582 8.18a1 1 0 0 0-1.414 1.414l1.411 1.41-1.411 1.412a1 1 0 0 0 1.414 1.414l1.411-1.411 1.418 1.418a1 1 0 0 0 1.414-1.414l-1.418-1.418 1.418-1.418a1 1 0 0 0 0-1.414"
}, null, -1), Dn = [
  xn
];
function Wn(e, t) {
  return o(), s("svg", _n, [...Dn]);
}
const Rn = { render: Wn }, Fn = /* @__PURE__ */ y({
  __name: "nothingFoundText",
  props: {
    noFoundText: {
      type: String,
      required: !0
    },
    variant: {
      type: String,
      default: null
    }
  },
  setup(e) {
    return (t, a) => (o(), s("div", {
      class: p(["bitSearchInputResultsNotFound", { bitSearchInputResultsNotFoundSm: e.variant === "sm" }])
    }, [
      V(C(Rn), { class: "bitSearchInputNotFoundSvg" }),
      l("p", null, c(e.noFoundText), 1)
    ], 2));
  }
}), Pn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, On = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16m3.527 4.46a1 1 0 0 0-1.415 0l-2.118 2.118-2.117-2.117a1 1 0 0 0-1.414 1.414l2.117 2.117-2.124 2.125a1.001 1.001 0 0 0 1.414 1.415l2.125-2.125 2.125 2.125a1 1 0 0 0 1.414-1.415l-2.125-2.125 2.118-2.117a1 1 0 0 0 0-1.414"
}, null, -1), Hn = [
  On
];
function zn(e, t) {
  return o(), s("svg", Pn, [...Hn]);
}
const qn = { render: zn }, Un = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none",
  viewBox: "0 0 19 19"
}, Gn = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "m18.78 17.72-4.477-4.477a7.512 7.512 0 1 0-1.06 1.06l4.477 4.477a.75.75 0 0 0 1.06-1.06M8.5 14.5a6 6 0 1 1 6-6 6.007 6.007 0 0 1-6 6"
}, null, -1), Kn = [
  Gn
];
function jn(e, t) {
  return o(), s("svg", Un, [...Kn]);
}
const Yn = { render: jn }, Jn = ["autofocus", "placeholder"], Zn = {
  key: 0,
  class: "bitSearchInputHelperText"
}, ns = /* @__PURE__ */ y({
  __name: "searchInput",
  props: {
    placeholder: {
      type: String,
      default: "Search"
    },
    inputValue: {
      type: String,
      default: ""
    },
    noSearchErrors: {
      type: Boolean,
      default: !1
    },
    noResultsFound: {
      type: Boolean,
      default: !0
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    gamePageMultimodeSearch: {
      type: Boolean,
      default: !1
    },
    noFoundText: {
      type: String,
      default: ""
    },
    searchHelpText: {
      type: String,
      default: ""
    }
  },
  emits: ["searchChanged", "onChangeEvent", "onEscDownEvent"],
  setup(e, { emit: t }) {
    const a = e, i = t, n = N(""), d = N(null), u = w(() => n.value.length >= 1 && n.value.length <= 2);
    x(
      () => a.inputValue,
      () => n.value = a.inputValue
    ), x(
      () => n.value,
      (v) => {
        i("searchChanged", v);
      }
    );
    const m = () => {
      n.value = "", P(() => {
        var v;
        (v = d.value) == null || v.focus();
      });
    }, h = (v) => {
      var B;
      !v.target.classList.contains("bitSearchInputCleanIcon") && !v.target.closest(".bitSearchInputHolder") && ((B = d.value) == null || B.blur());
    };
    return W(() => {
      window.addEventListener("touchstart", h), window.addEventListener("click", h), a.autofocus && P(() => {
        setTimeout(() => {
          var v;
          (v = d.value) == null || v.focus();
        }, 0);
      });
    }), q(() => {
      window.removeEventListener("touchstart", h), window.removeEventListener("click", h);
    }), (v, B) => (o(), s("div", {
      class: p(["bitSearchInput", {
        gamePageMultimodeSearchInput: e.gamePageMultimodeSearch
      }])
    }, [
      l("div", {
        class: p(["bitSearchInputHolder", {
          bitSearchInputErrorSearch: n.value.length <= 2 && n.value.length > 0 && !e.noSearchErrors
        }])
      }, [
        V(C(Yn), { class: "bitSearchInputGlass" }),
        H(l("input", {
          ref_key: "searchInput",
          ref: d,
          "onUpdate:modelValue": B[0] || (B[0] = (b) => n.value = b),
          type: "text",
          class: "bitSearchInputInput",
          autofocus: e.autofocus,
          placeholder: e.placeholder,
          onChange: B[1] || (B[1] = (b) => v.$emit("onChangeEvent")),
          onKeydown: B[2] || (B[2] = Q((b) => v.$emit("onEscDownEvent"), ["esc"]))
        }, null, 40, Jn), [
          [X, n.value]
        ]),
        n.value.length >= 1 ? (o(), I(C(qn), {
          key: 0,
          class: "bitSearchInputCleanIcon",
          loading: "lazy",
          onClick: z(m, ["prevent"])
        })) : f("", !0)
      ], 2),
      u.value && !e.noSearchErrors ? (o(), s("div", Zn, c(e.searchHelpText), 1)) : f("", !0),
      e.noResultsFound && (n.value.length >= 3 && !e.noSearchErrors || n.value.length && e.noSearchErrors) ? (o(), I(Fn, {
        key: 1,
        variant: e.gamePageMultimodeSearch ? "sm" : null,
        "no-found-text": e.noFoundText
      }, null, 8, ["variant", "no-found-text"])) : f("", !0)
    ], 2));
  }
}), Qn = { class: "bitSelectProtocol" }, os = /* @__PURE__ */ y({
  __name: "selectProtocol",
  props: {
    protocols: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = t, i = (n) => {
      a("update:modelValue", n);
    };
    return (n, d) => (o(), s("div", Qn, [
      (o(!0), s(re, null, de(e.protocols, (u) => (o(), I(te, {
        key: u,
        "is-fluid-width": "",
        active: u === e.modelValue,
        type: "button",
        onClick: (m) => i(u)
      }, {
        default: E(() => [
          F(c(u), 1)
        ]),
        _: 2
      }, 1032, ["active", "onClick"]))), 128))
    ]));
  }
}), Xn = { class: "bitSelectItemOption" }, eo = {
  key: 0,
  class: "bitSelectItemIconAppend"
}, to = { class: "bitSelectItemText" }, ao = {
  key: 1,
  class: "bitSelectItemAdditionalText"
}, no = { class: "bitSelectItemSelectedIcon" }, oo = /* @__PURE__ */ y({
  __name: "selectItem",
  props: {
    tag: {
      type: String,
      default: "li"
    },
    isSelected: {
      type: Boolean,
      default: !1
    },
    optionText: {
      type: [String, Number, Object],
      default: ""
    },
    additionalText: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["click"],
  setup(e) {
    return (t, a) => (o(), I(D(e.tag), {
      class: p(["bitSelectItem", { bitSelectItemSelected: e.isSelected, bitSelectItemLong: e.additionalText }]),
      onClick: a[0] || (a[0] = (i) => t.$emit("click"))
    }, {
      default: E(() => [
        l("span", Xn, [
          t.$slots.appendOptionIcon ? (o(), s("span", eo, [
            S(t.$slots, "appendOptionIcon")
          ])) : f("", !0),
          l("span", to, c(e.optionText), 1),
          e.additionalText ? (o(), s("span", ao, c(e.additionalText), 1)) : f("", !0)
        ]),
        l("span", no, [
          e.isSelected ? (o(), I(C(ne), { key: 0 })) : f("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), R = "__v-click-outside", io = typeof window < "u", so = ["click"];
function lo(e) {
  const t = typeof e == "function";
  if (!t && typeof e != "object")
    throw new Error("v-click-outside: Binding value must be a function or an object");
  return {
    handler: t ? e : e.handler,
    middleware: e.middleware || ((a) => a),
    events: e.events || so,
    isActive: e.isActive !== !1,
    detectIframe: e.detectIframe !== !1,
    capture: !!e.capture
  };
}
function he({ event: e, handler: t, middleware: a }) {
  a(e) && t(e);
}
function ro({ el: e, event: t, handler: a, middleware: i }) {
  setTimeout(() => {
    const { activeElement: n } = document;
    n && n.tagName === "IFRAME" && !e.contains(n) && he({ event: t, handler: a, middleware: i });
  }, 0);
}
function uo({ el: e, event: t, handler: a, middleware: i }) {
  const n = t.composedPath && t.composedPath() || t.path;
  (n ? !n.includes(e) : !e.contains(t.target)) && he({ event: t, handler: a, middleware: i });
}
function pe(e, { value: t }) {
  const { events: a, handler: i, middleware: n, isActive: d, detectIframe: u, capture: m } = lo(t);
  if (d) {
    if (e[R] = a.map((h) => ({
      event: h,
      srcTarget: document.documentElement,
      handler: (v) => uo({ el: e, event: v, handler: i, middleware: n }),
      capture: m
    })), u) {
      const h = {
        event: "blur",
        srcTarget: window,
        handler: (v) => ro({ el: e, event: v, handler: i, middleware: n }),
        capture: m
      };
      e[R] = [...e[R], h];
    }
    e[R].forEach(
      ({ event: h, srcTarget: v, handler: B }) => setTimeout(() => {
        e[R] && v.addEventListener(h, B, m);
      }, 0)
    );
  }
}
function fe(e) {
  (e[R] || []).forEach(
    ({ event: a, srcTarget: i, handler: n, capture: d }) => i.removeEventListener(a, n, d)
  ), delete e[R];
}
function co(e, { value: t, oldValue: a }) {
  JSON.stringify(t) !== JSON.stringify(a) && (fe(e), pe(e, { value: t }));
}
const mo = {
  beforeMount: pe,
  updated: co,
  unmounted: fe
}, ho = io ? mo : {}, po = {
  key: 0,
  class: "bitSelectLabelText"
}, fo = ["gtmid"], go = {
  key: 0,
  class: "bitSelectIconAppendInput"
}, yo = ["gtmid"], vo = { class: "bitSelectIconDefault" }, bo = { class: "bitSelectList" }, $o = {
  key: 1,
  class: "bitSelectErrorText"
}, Z = /* @__PURE__ */ y({
  __name: "select",
  props: {
    options: {
      type: [Object, Array],
      required: !0
    },
    defaultIndex: {
      type: [String, Number],
      default: null
    },
    modelValue: {
      type: [String, Number],
      default: () => null
    },
    defaultValue: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    locked: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    isError: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    textLabel: {
      type: String,
      default: ""
    },
    customSelectedLabel: {
      type: String,
      default: null
    },
    isNoMargin: {
      type: Boolean,
      default: !1
    },
    isNoErrorMessage: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: null
    },
    gtmid: {
      type: String,
      default: null
    },
    dropdownOpenDirection: {
      type: String,
      default: "bottom"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = ho, i = e, n = t, d = N(null), u = N(!1), m = w(() => !i.disabled && !i.locked), h = ($) => {
      if (Array.isArray(i == null ? void 0 : i.options)) {
        const r = i.options.findIndex((M) => String(M) === String($));
        if (r >= 0)
          return String(r);
      } else
        return String($);
      return null;
    };
    x(
      () => i.modelValue,
      () => {
        i.modelValue && (d.value = h(i.modelValue));
      },
      { immediate: !0 }
    );
    const v = () => {
      m.value && (u.value = !u.value);
    }, B = () => {
      u.value = !1;
    }, b = w(() => {
      if (Array.isArray(i == null ? void 0 : i.options)) {
        const $ = {};
        return i.options.forEach((r, M) => {
          $[String(M)] = r;
        }), $;
      } else
        return i == null ? void 0 : i.options;
    }), g = ($) => {
      Array.isArray(i == null ? void 0 : i.options) ? n("update:modelValue", $.value) : n("update:modelValue", $.index);
    }, A = w(() => i.placeholder || ""), k = w(() => d.value === null ? i.defaultIndex ? String(i.defaultIndex) : i.defaultValue ? h(i.defaultValue) : "" : String(d.value)), _ = w(() => k.value === null || !b.value[k.value] ? "" : String(b.value[k.value])), T = ($) => {
      d.value = $, B(), g({
        index: k.value,
        value: _.value
      });
    };
    return ($, r) => H((o(), s("div", {
      class: p(["bitSelect", [
        {
          bitSelectNoMargin: e.isNoMargin,
          bitSelectError: e.isError && m.value,
          bitSelectErrorNoMessage: e.isError && e.isNoErrorMessage,
          bitSelectDisabled: e.disabled || e.locked,
          bitSelectVariantFilter: e.variant === "filter",
          bitSelectVariantCurrencySm: e.variant === "currency-small",
          bitSelectVariantLanguage: e.variant === "language"
        },
        `bitSelectOpen-${e.dropdownOpenDirection}`
      ]])
    }, [
      e.textLabel ? (o(), s("label", po, c(e.textLabel), 1)) : f("", !0),
      l("span", {
        "data-name": "dropdown_name",
        class: p(["bitSelectName", [
          {
            bitSelectNameActive: u.value,
            bitSelectNamePlaceholderActive: !_.value
          }
        ]]),
        gtmid: e.gtmid,
        onClick: r[0] || (r[0] = (M) => v())
      }, [
        $.$slots.appendInputIcon ? (o(), s("span", go, [
          S($.$slots, "appendInputIcon")
        ])) : f("", !0),
        l("span", {
          class: "bitSelectText",
          gtmid: e.gtmid
        }, c(e.customSelectedLabel || _.value || A.value), 9, yo),
        l("span", vo, [
          e.locked ? (o(), I(C(ce), { key: 1 })) : (o(), I(C(Y), {
            key: 0,
            class: "bitSelectIconArrow",
            gtmid: e.gtmid
          }, null, 8, ["gtmid"]))
        ])
      ], 10, fo),
      l("div", {
        class: p(["bitSelectContainer", { bitSelectShow: u.value }])
      }, [
        l("ul", bo, [
          (o(!0), s(re, null, de(e.options, (M, L) => (o(), I(oo, {
            key: L,
            "option-text": M || "",
            "is-selected": L == k.value,
            onClick: (O) => T(String(L))
          }, ee({ _: 2 }, [
            $.$slots.appendOptionIcon ? {
              name: "appendOptionIcon",
              fn: E(() => [
                S($.$slots, "appendOptionIcon", { value: M })
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["option-text", "is-selected", "onClick"]))), 128))
        ])
      ], 2),
      e.isError && m.value && !e.isNoErrorMessage && e.errorMessage ? (o(), s("span", $o, c(e.errorMessage), 1)) : f("", !0)
    ], 2)), [
      [C(a), B]
    ]);
  }
}), Bo = { class: "bitBirthSelectLabelText" }, So = { class: "bitBirthSelectWrapper" }, Io = {
  key: 0,
  class: "bitBirthSelectErrorMessage"
}, Co = {
  key: 1,
  class: "bitBirthSelectErrorMessage"
}, is = /* @__PURE__ */ y({
  __name: "dateOfBirthSelect",
  props: {
    errorMessage: {
      type: String,
      default: ""
    },
    modelValue: {
      type: String,
      default: ""
    },
    isError: {
      type: Boolean,
      default: !1
    },
    locked: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    labelText: {
      type: String,
      default: ""
    },
    notEnoughYearsMessage: {
      type: String,
      default: ""
    },
    yearPlaceholder: {
      type: String,
      default: ""
    },
    monthPlaceholder: {
      type: String,
      default: ""
    },
    dayPlaceholder: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "hasEnoughYears"],
  setup(e, { emit: t }) {
    const a = e, i = t, n = K({
      month: "",
      year: "",
      day: ""
    }), d = K({
      month: !1,
      year: !1,
      day: !1
    }), u = w(() => {
      const T = [], $ = (/* @__PURE__ */ new Date()).getFullYear();
      for (let r = $; r > $ - 100; --r)
        T.push(r);
      return T;
    }), m = w(() => [...Array(13).keys()].slice(1)), h = w(() => [...Array(32).keys()].slice(1)), v = w(
      () => !!(!n.day || !n.month || !n.year || g.value)
    ), B = (T) => {
      const $ = /* @__PURE__ */ new Date(), r = new Date(T);
      let M = $.getFullYear() - r.getFullYear();
      const L = $.getMonth() - r.getMonth();
      return (L < 0 || L === 0 && $.getDate() < r.getDate()) && M--, M;
    }, b = w(() => {
      const T = +n.day > 9 ? +n.day : `0${n.day}`, $ = +n.month > 9 ? +n.month : `0${n.month}`;
      return `${n.year}-${$}-${T}`;
    }), g = w(() => {
      let T = null;
      return n.day && n.month && n.year && B(Date.parse(b.value)) < 18 && (T = a.notEnoughYearsMessage), T;
    }), A = w(
      () => g.value && g.value || a.errorMessage
    ), k = w(() => d.day && d.month && d.year), _ = w(() => d.day || d.month || d.year);
    return x([() => b.value, () => g.value], () => {
      n.day && n.month && n.year && !g.value && _.value && (i("update:modelValue", b.value), i("hasEnoughYears", !0));
    }), x(
      () => g.value,
      (T) => {
        i("hasEnoughYears", !T);
      }
    ), W(() => {
      var T, $, r;
      if (a.modelValue) {
        const M = Number((T = a.modelValue.split("-")) == null ? void 0 : T[0]) || n.year, L = Number(($ = a.modelValue.split("-")) == null ? void 0 : $[1]) || n.month, O = Number((r = a.modelValue.split("-")) == null ? void 0 : r[2]) || n.day;
        n.day = O, n.month = L, n.year = M;
      }
    }), (T, $) => (o(), s("div", {
      class: p(["bitBirthSelect", [
        {
          bitBirthSelectSelectError: !!g.value || e.isError,
          bitBirthSelectDisabled: e.locked || e.disabled
        }
      ]])
    }, [
      l("div", Bo, c(e.labelText), 1),
      l("div", So, [
        V(Z, {
          modelValue: n.day,
          "onUpdate:modelValue": [
            $[0] || ($[0] = (r) => n.day = r),
            $[1] || ($[1] = (r) => d.day = !0)
          ],
          class: "bitBirthSelectItem",
          "is-no-margin": "",
          options: h.value,
          "is-error": !!g.value || e.isError,
          "is-success": !v.value && k.value,
          placeholder: e.dayPlaceholder,
          locked: e.locked,
          disabled: e.disabled
        }, null, 8, ["modelValue", "options", "is-error", "is-success", "placeholder", "locked", "disabled"]),
        V(Z, {
          modelValue: n.month,
          "onUpdate:modelValue": [
            $[2] || ($[2] = (r) => n.month = r),
            $[3] || ($[3] = (r) => d.month = !0)
          ],
          class: "bitBirthSelectItem",
          options: m.value,
          "is-no-margin": "",
          "is-error": !!g.value || e.isError,
          "is-success": !v.value && k.value,
          placeholder: e.monthPlaceholder,
          locked: e.locked,
          disabled: e.disabled
        }, null, 8, ["modelValue", "options", "is-error", "is-success", "placeholder", "locked", "disabled"]),
        V(Z, {
          modelValue: n.year,
          "onUpdate:modelValue": [
            $[4] || ($[4] = (r) => n.year = r),
            $[5] || ($[5] = (r) => d.year = !0)
          ],
          class: "bitBirthSelectItem",
          options: u.value,
          "is-no-margin": "",
          "is-error": !!g.value || e.isError,
          "is-success": !v.value && k.value,
          placeholder: e.yearPlaceholder,
          locked: e.locked,
          disabled: e.disabled
        }, null, 8, ["modelValue", "options", "is-error", "is-success", "placeholder", "locked", "disabled"])
      ]),
      v.value ? (o(), s("span", Io, c(A.value), 1)) : e.isError ? (o(), s("span", Co, c(e.errorMessage), 1)) : f("", !0)
    ], 2));
  }
}), To = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, wo = /* @__PURE__ */ l("path", {
  fill: "#F9BC06",
  d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12C5.376 23.993.007 18.625 0 12 0 5.373 5.373 0 12 0m0 16.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0-12A1.5 1.5 0 0 0 10.5 6v6a1.5 1.5 0 0 0 3 0V6A1.5 1.5 0 0 0 12 4.5"
}, null, -1), ko = [
  wo
];
function Mo(e, t) {
  return o(), s("svg", To, [...ko]);
}
const Lo = { render: Mo }, Ao = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, Vo = /* @__PURE__ */ l("path", {
  fill: "#FA3848",
  d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m5.291 6.691a1.5 1.5 0 0 0-2.123 0l-3.177 3.176-3.176-3.176a1.5 1.5 0 0 0-2.12 2.122l3.175 3.175-3.186 3.188a1.5 1.5 0 0 0 2.121 2.123l3.188-3.188 3.187 3.187a1.5 1.5 0 0 0 2.121-2.122l-3.187-3.188 3.177-3.175a1.5 1.5 0 0 0 0-2.122"
}, null, -1), Eo = [
  Vo
];
function No(e, t) {
  return o(), s("svg", Ao, [...Eo]);
}
const _o = { render: No }, xo = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "16",
  fill: "none",
  viewBox: "0 0 22 16"
}, Do = /* @__PURE__ */ l("path", {
  fill: "#05C756",
  d: "M17.352 1.42a2.334 2.334 0 0 1 3.3 0l.16.177a2.334 2.334 0 0 1-.16 3.122L10.649 14.722l-.176.16a2.335 2.335 0 0 1-2.945 0l-.178-.16-6.253-6.253a2.333 2.333 0 0 1-.16-3.121l.16-.178a2.334 2.334 0 0 1 3.301 0L9 9.773z"
}, null, -1), Wo = [
  Do
];
function Ro(e, t) {
  return o(), s("svg", xo, [...Wo]);
}
const Fo = { render: Ro }, Po = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "24",
  fill: "none",
  viewBox: "0 0 22 24"
}, Oo = /* @__PURE__ */ l("path", {
  fill: "#916AFB",
  d: "M11 0a6.667 6.667 0 0 1 6.667 6.667V8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4.333a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4V6.667A6.667 6.667 0 0 1 11 0m0 13.333c-.736 0-1.333.597-1.333 1.334v2.666a1.333 1.333 0 1 0 2.666 0v-2.666c0-.737-.597-1.334-1.333-1.334m0-10.666a4 4 0 0 0-4 4V8h8V6.667a4 4 0 0 0-4-4"
}, null, -1), Ho = [
  Oo
];
function zo(e, t) {
  return o(), s("svg", Po, [...Ho]);
}
const qo = { render: zo }, Uo = {
  key: 0,
  class: "bitInfoBannerInfoMessage"
}, Go = { class: "bitInfoBannerMessageText" }, Ko = {
  key: 4,
  class: "bitInfoBannerHeader"
}, jo = {
  key: 5,
  class: "bitInfoBannerMessageText"
}, Yo = {
  key: 6,
  class: "bitInfoBannerMessageText"
}, Jo = ["href"], ss = /* @__PURE__ */ y({
  __name: "infoBanner",
  props: {
    bannerType: {
      type: String,
      required: !0
    },
    messageText: {
      type: String,
      default: ""
    },
    attentionHeaderTitle: {
      type: String,
      required: !1,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    titleLink: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, a) => (o(), s("div", {
      class: p(["bitInfoBanner", { bitInfoBannerWithHeader: e.attentionHeaderTitle }])
    }, [
      e.bannerType === "information" ? (o(), s("div", Uo, [
        l("div", Go, [
          S(t.$slots, "information-text")
        ])
      ])) : (o(), s("div", {
        key: 1,
        class: p([
          "bitInfoBannerMessage",
          {
            bitInfoBannerErrorMessage: e.bannerType === "error"
          }
        ])
      }, [
        e.bannerType === "attention" ? (o(), I(C(Lo), {
          key: 0,
          class: "bitInfoBannerIcon"
        })) : e.bannerType === "locked" ? (o(), I(C(qo), {
          key: 1,
          class: "bitInfoBannerIcon"
        })) : e.bannerType === "error" ? (o(), I(C(_o), {
          key: 2,
          class: "bitInfoBannerIcon"
        })) : (o(), I(C(Fo), {
          key: 3,
          class: "bitInfoBannerIcon"
        })),
        e.attentionHeaderTitle ? (o(), s("span", Ko, c(e.attentionHeaderTitle), 1)) : f("", !0),
        t.$slots["message-text"] ? (o(), s("p", jo, [
          S(t.$slots, "message-text")
        ])) : (o(), s("p", Yo, [
          F(c(e.messageText) + " ", 1),
          e.link ? (o(), s("a", {
            key: 0,
            href: e.link,
            target: "_blank",
            class: "bitInfoBannerLink"
          }, c(e.titleLink), 9, Jo)) : f("", !0)
        ]))
      ], 2))
    ], 2));
  }
}), ls = /* @__PURE__ */ y({
  __name: "statusGroup",
  props: {
    status: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, a) => (o(), s("span", {
      class: p(["bitStatusGroup", e.status])
    }, [
      S(t.$slots, "default")
    ], 2));
  }
}), Zo = { class: "bitTableRowLeft" }, rs = /* @__PURE__ */ y({
  __name: "tableRow",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    isNoHighlight: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, a) => (o(), I(D(e.tag), { class: "bitTableRow" }, {
      default: E(() => [
        l("div", Zo, [
          S(t.$slots, "left-title")
        ]),
        l("div", {
          class: p(["bitTableRowRight", { bitTableRowNoHighlight: e.isNoHighlight }])
        }, [
          S(t.$slots, "right-title")
        ], 2)
      ]),
      _: 3
    }));
  }
}), ds = /* @__PURE__ */ y({
  __name: "tableWrapper",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(e) {
    return (t, a) => (o(), I(D(e.tag), { class: "bitTableWrapper" }, {
      default: E(() => [
        S(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Qo = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Xo = /* @__PURE__ */ l("path", {
  fill: "#fff",
  d: "M12.714 2.343 8 7.057 3.286 2.343a.667.667 0 1 0-.943.943L7.057 8l-4.714 4.714a.667.667 0 0 0 .943.943L8 8.943l4.714 4.714a.667.667 0 0 0 .943-.943L8.943 8l4.714-4.714a.667.667 0 0 0-.943-.943"
}, null, -1), ei = [
  Xo
];
function ti(e, t) {
  return o(), s("svg", Qo, [...ei]);
}
const ai = { render: ti }, ni = { class: "bitChipsTabButton" }, oi = { class: "bitChipsTabButtonText" }, us = /* @__PURE__ */ y({
  __name: "chipsTabButton",
  emits: ["changed"],
  setup(e, { emit: t }) {
    const a = t;
    return W(async () => {
      await P(), a("changed");
    }), ye(() => {
      a("changed");
    }), (i, n) => (o(), s("button", ni, [
      l("span", oi, [
        S(i.$slots, "default")
      ]),
      V(C(ai), { class: "bitChipsTabButtonCloseIcon" })
    ]));
  }
}), ii = { class: "bitCurrencyTabButtonIcon" }, si = { class: "bitCurrencyTabButtonText" }, cs = /* @__PURE__ */ y({
  __name: "currencyTabButton",
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    }
  },
  setup(e) {
    return (t, a) => (o(), s("button", {
      class: p(["bitCurrencyTabButton", [{ bitCurrencyTabButtonActiveActive: e.active }, `bitCurrencyTabButtonActiveSize${e.size}`]])
    }, [
      l("span", ii, [
        S(t.$slots, "icon")
      ]),
      l("span", si, [
        S(t.$slots, "default")
      ])
    ], 2));
  }
}), li = {
  key: 0,
  class: "bitNavBarTabButtonIcon"
}, ri = { class: "bitNavBarTabButtonText" }, ms = /* @__PURE__ */ y({
  __name: "navBarTabButton",
  props: {
    tag: {
      type: String,
      default: "a"
    },
    active: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "horizontal"
    }
  },
  setup(e) {
    return (t, a) => (o(), I(D(e.tag), {
      class: p(["bitNavBarTabButton", [{ bitNavBarTabButtonActive: e.active }, e.variant]])
    }, {
      default: E(() => [
        t.$slots.icon ? (o(), s("span", li, [
          S(t.$slots, "icon")
        ])) : f("", !0),
        l("span", ri, [
          S(t.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), di = ["src"], ui = {
  key: 1,
  class: "paymentOffersName"
}, hs = /* @__PURE__ */ y({
  __name: "paymentTabButton",
  props: {
    imageUrl: {
      type: String,
      required: !1,
      default: ""
    },
    active: {
      type: Boolean,
      default: !1
    },
    methodName: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(e) {
    return (t, a) => (o(), s("div", {
      class: p(["paymentOffersItem", [{ selected: e.active }]])
    }, [
      e.imageUrl ? (o(), s("img", {
        key: 0,
        class: "paymentOffersImg",
        src: e.imageUrl,
        alt: "provider"
      }, null, 8, di)) : f("", !0),
      e.methodName ? (o(), s("span", ui, c(e.methodName), 1)) : f("", !0)
    ], 2));
  }
}), ci = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, mi = /* @__PURE__ */ l("path", {
  fill: "#626C9D",
  d: "M12 3a9.01 9.01 0 0 1 9 9 9 9 0 1 1-9-9m0 2.7a.9.9 0 0 0-.9.9v5.027c0 .477.19.936.527 1.273l2.436 2.436.069.062a.9.9 0 0 0 1.265-1.266l-.061-.069-2.436-2.436V6.6a.9.9 0 0 0-.9-.9"
}, null, -1), hi = [
  mi
];
function pi(e, t) {
  return o(), s("svg", ci, [...hi]);
}
const fi = { render: pi }, gi = {
  key: 0,
  class: "bitTimerBlockHours"
}, yi = { class: "bitTimerBlockDay" }, vi = /* @__PURE__ */ l("span", { class: "bitTimerBlockDots" }, ":", -1), bi = {
  key: 1,
  class: "bitTimerBlockHours"
}, $i = { class: "bitTimerBlockDay" }, Bi = /* @__PURE__ */ l("span", { class: "bitTimerBlockDots" }, ":", -1), Si = {
  key: 2,
  class: "bitTimerBlockHours bitTimerBlockMinutes"
}, Ii = { class: "bitTimerBlockDay" }, Ci = {
  key: 3,
  class: "bitTimerBlockHours bitTimerBlockSeconds"
}, Ti = {
  key: 0,
  class: "bitTimerBlockDots"
}, wi = { class: "bitTimerBlockDay" }, ps = /* @__PURE__ */ y({
  __name: "timer",
  props: {
    startTime: {
      type: Number,
      requred: !1,
      default: 0
    },
    endTime: {
      type: Number,
      requred: !1,
      default: 0
    },
    titleDays: {
      type: String,
      default: ""
    },
    titleHours: {
      type: String,
      default: ""
    },
    titleMinutes: {
      type: String,
      default: ""
    },
    titleSeconds: {
      type: String,
      default: ""
    },
    isMini: {
      type: Boolean,
      default: !1
    },
    isBackground: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["timeOut"],
  setup(e, { emit: t }) {
    const a = e, i = t, n = N(!0);
    W(() => {
      m(), n.value = !1, u.value = window.setInterval(() => {
        m(), n.value = !1;
      }, 1e3);
    }), q(() => {
      window.clearInterval(u.value);
    });
    const d = K({
      days: NaN,
      hours: NaN,
      minutes: NaN,
      seconds: NaN
    }), u = N(NaN), m = () => {
      const _ = Date.now();
      if (a.endTime || _ < a.startTime) {
        let T = Math.max(
          _ < a.startTime ? a.startTime - _ : a.endTime - _,
          0
        );
        T || (i("timeOut"), window.clearInterval(u.value)), d.days = Math.floor(T / 1e3 / 60 / 60 / 24), T -= d.days * 1e3 * 60 * 60 * 24, d.hours = Math.floor(T / 1e3 / 60 / 60), T -= d.hours * 1e3 * 60 * 60, d.minutes = Math.floor(T / 1e3 / 60), T -= d.minutes * 1e3 * 60, d.seconds = Math.floor(T / 1e3);
      } else
        d.days = NaN, d.hours = NaN, d.minutes = NaN, d.seconds = NaN;
    }, h = w(() => a.endTime || a.startTime), v = w(() => d.days >= 0 ? String(d.days) : "..."), B = w(() => d.hours >= 0 ? String(d.hours) : "..."), b = w(() => d.minutes >= 0 ? String(d.minutes) : "..."), g = w(() => d.seconds >= 0 ? String(d.seconds) : "..."), A = w(() => d.minutes <= 9 ? "0" : ""), k = w(() => d.seconds <= 9 ? "0" : "");
    return (_, T) => {
      var $, r, M, L;
      return h.value ? (o(), s("div", {
        key: 0,
        class: p(["bitTimer", { bitTimerMini: e.isMini, bitBackground: e.isBackground }])
      }, [
        V(C(fi), {
          class: "bitTimerIcon",
          height: "20",
          width: "20"
        }),
        v.value > "0" ? (o(), s("span", gi, [
          l("span", yi, c(v.value) + c(($ = e.titleDays[0]) == null ? void 0 : $.toLowerCase()), 1),
          vi
        ])) : f("", !0),
        B.value > "0" || v.value > "0" ? (o(), s("span", bi, [
          l("span", $i, c(B.value) + c((r = e.titleHours[0]) == null ? void 0 : r.toLowerCase()), 1),
          Bi
        ])) : f("", !0),
        b.value > "0" || B.value > "0" || v.value > "0" ? (o(), s("span", Si, [
          l("span", Ii, c(A.value) + c(b.value), 1),
          l("span", null, c((M = e.titleMinutes[0]) == null ? void 0 : M.toLowerCase()), 1)
        ])) : f("", !0),
        v.value === "0" ? (o(), s("span", Ci, [
          b.value > "0" ? (o(), s("span", Ti, ":")) : f("", !0),
          l("span", wi, c(k.value) + c(g.value), 1),
          l("span", null, c((L = e.titleSeconds[0]) == null ? void 0 : L.toLowerCase()), 1)
        ])) : f("", !0)
      ], 2)) : f("", !0);
    };
  }
});
export {
  Mi as BitAccordionItem,
  Li as BitBottomSheetHeader,
  oe as BitButton,
  Ui as BitCardDateInput,
  xi as BitCardLabel,
  Gi as BitCardNumberInput,
  Di as BitCashbackCard,
  Ri as BitCheckbox,
  us as BitChipsTabButton,
  Ne as BitCloseButton,
  Wi as BitCollectionCard,
  Pi as BitCollectionFilterItem,
  Ai as BitControlButton,
  cs as BitCurrencyTabButton,
  Ki as BitCvvInput,
  is as BitDateOfBirthSelect,
  Hi as BitFavoriteIconButton,
  qi as BitGenderSelection,
  Xi as BitHeaderNavButton,
  ss as BitInfoBanner,
  J as BitInput,
  ji as BitInputBonusCode,
  Vi as BitLinkButton,
  Qi as BitMenuScrollable,
  le as BitNavArrowButton,
  es as BitNavBarAdditionalButton,
  ts as BitNavBarRegularButton,
  ms as BitNavBarTabButton,
  Te as BitNavExpandButton,
  Ei as BitOverlayButton,
  Yi as BitPasswordInput,
  as as BitPaymentMethodCard,
  Oi as BitProviderFilterItem,
  ie as BitRadioButton,
  Ji as BitRedirectMenuItem,
  ns as BitSearchInput,
  Z as BitSelect,
  oo as BitSelectItem,
  os as BitSelectProtocol,
  ls as BitStatusGroup,
  Fi as BitSwitch,
  te as BitTabButton,
  rs as BitTableRow,
  ds as BitTableWrapper,
  zi as BitThumbLabel,
  ps as BitTimer,
  ae as BitTooltip,
  st as BitTooltipText,
  Zi as BitTrailMenuItem,
  Ni as BuyCryptoOffer,
  _i as BuyCryptoTransactions,
  hs as PaymentTabButton
};
